import { Component, HostListener, OnInit, Pipe, PipeTransform, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActionControl, AuthorizePaymentType, BookingBehavior, ComponentTypes,PaymentItemType } from 'src/app/shared/constants/commonenums';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import {
  CustomFieldsDTO, FinancialEffectForUpdatedReservationDTO,
  PaymentGateways, PaymentStates, RegisterReservationAttemptResponseDTO, SecondaryContactDTO, FinancialEffectType, PaymentMethod, PaymentMode, PricingStrategy
} from 'src/app/shared/Models/PartyModels';
import { BookingActivity } from 'src/app/shared/Models/SessionBookingDTO';
import { SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { ConfirmationVia, TaxType, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';
import { Validators } from '@angular/forms';
import { ValidationMessageType } from 'src/app/shared/Models/ResultModels';
import * as _ from 'lodash';
import { ActivitiesDataDic } from '../activities-lite.data';

@Component({
    selector: 'app-activities-lite-order-summary',
    templateUrl: './activities-lite-order-summary.component.html',
    styleUrls: ['./activities-lite-order-summary.component.scss', './../activities-lite.component.scss'],
    standalone: false
})
export class ActivitiesLiteOrderSummaryComponent implements OnInit, AfterViewInit {

  operationCurrency: any;
  isSessionClass: boolean;
  subscriptions: Subscription = new Subscription();
  guestDetails: any = [];
  selectedAdditionalGuest = 1;
  taxType = TaxType;
  @ViewChild('guestDetailsForm') guestDetailsForm;
  saveCardToContact = false;
  showIframe = false;
  IframeURL = '';
  urlSafe: SafeResourceUrl;
  waiverForm: boolean;
  operationType = operationType;
  applyToAllGuests = false;
  showDetailedView = false;
  paymentGateway: number;
  taxTypeForBooking = TaxType.Tax;
  waiverFormTrancationId = null;
  paymentData: any;
  TotalAmount: number = 0;
  PayableAmount: number = 0;
  isUserAllowedToclickConfirm: boolean;
  components: any;
  freeTextIdList = [];
  isSplitPayment: boolean;
  formSubmitted = false;
  customTerms = [];
  reminderSmsEmailChecks = [];
  bookingCompleted: boolean;
  creditCardPaid: boolean;
  PaymentItemType = PaymentItemType;
  confToken: any;
  popUpMessage = '';
  financialData: FinancialEffectForUpdatedReservationDTO;
  refundData: any;
  isAuthRefund: boolean;
  financialPopUpRef: MatDialogRef<any>;
  clearCartDialogRef: MatDialogRef<any>;
  bookingErrorDialogRef: MatDialogRef<any>;
  checkBoxErrorMessages = '';
  countryList = [];
  mobileNumberLength = 10;
  widgetSettings: any = {};
  totalActivitiesRegistered = [];
  cartItems = [];
  isEdit = false;
  balanceAmount: number = 0;
  refundAmount = false;
  noteType: number;
  guestPartySize = 0;
  enableSubmit = false;
  showCartLockWarning = false;
  restaurantData: any;
  totalTax: number = 0;
  totalServiceCharge: number = 0;
  subTotal: number = 0;
  taxOnServiceCharge: number = 0;
  financialEffectId:number= 0;
  AuthOnlyPaymentMode: 6 = 6;
  transactions = []
  rGuestPayResponseData: any;
  infoMessage: string = '';
  showCardOnFileInformation  = false;
  paymentOffline: boolean = false;
  overallBookings = null;
  _MESSAGES = MESSAGES;
  showSCDetails = false;
  showTaxDetails = false;
  showVATDetails = false;
  disableSubmitButton : boolean = true;
  validationMessageList: string[] = [];;
  isValidateTerms: boolean= false;
  handleInterval;


  constructor(
    private ts: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public activityService: GuestService,
    public sanitizer: DomSanitizer,
    public dfs: DynamicFormService,
    private activitiesDataDic: ActivitiesDataDic
  ) {
  }

  @HostListener('window:message', ['$event'])
  onMessage({ origin, data }) {
     if (origin !== environment.authorizeIframeResponseOrigin && origin !== environment.rGuestPayIframeResponsOrigin) { // set your origin
       return false;
     }
    this.rGuestPayResponseData = null;
    let rGuestPayRespose = data;
    const payResponse = data;
    /** Bug Fix | Issue: 62617 | Root: ReservationAttemptIds were always sent with only the first element [0] | Fix: Now sending all ReservationAttemptIds | By: Pritha R | Date: 23-07-26 */
    const reservationAttemptIds = (this.paymentData?.ResponseDTOs?.flatMap((response: any) => response?.ReservationAttemptIds?.length ? response.ReservationAttemptIds : [])
      .filter((reservationAttemptId: number) => reservationAttemptId > 0)) ?? [];
    if (typeof data !== 'object') {
      rGuestPayRespose = JSON.parse(data);
    }
    if ((data.type === 'txn-completed' && data.transactionInfo
      && data.transactionInfo.transactionInfo && data.transactionInfo.transactionInfo.payments)
      || (rGuestPayRespose && (rGuestPayRespose.code || rGuestPayRespose.gatewayResponseData))) {
        this.transactions = [];
        
      if (data?.transactionInfo?.transactionInfo && data.transactionInfo.transactionInfo.successCode === 1 &&
        data.transactionInfo.transactionInfo.payments.length > 0 &&
        data.transactionInfo.transactionInfo.payments[0].paymentType === 7) { // Waiver form
        this.proceedReservation(data.transactionInfo.transactionInfo.payments[0].authorizeTransactionID);
        return;
      }

      if (this.paymentGateway === PaymentGateways.AuthorizePay) { // Authorize Pay

        const transInfo = payResponse.transactionInfo.transactionInfo;

        if (transInfo.errorMessage || transInfo.successCode !== 1) {
          if (transInfo.errorMessage) {
            this.activityService.openSnackBar
              (transInfo.errorMessage, this.ts.instant('close'), 15000, 'error-snackbar');
          }
          else {
            this.activityService.openSnackBar
              (this.ts.instant('CardInformationProcessNotCompleted'),
                this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
          }
        } else if (payResponse && transInfo && transInfo.successCode === 1) {

          this.transactions = this.processTransactions(transInfo);
          this.rGuestPayResponseData = data.transactionInfo.transactionInfo.payments[0].rGuestPayResponseData;
          let isCreditcardPayment  = !!this.transactions.find(payment => payment.PaymentType ==  AuthorizePaymentType.CreditCardToken || payment.PaymentType ==  AuthorizePaymentType.Payment_Only || payment.PaymentType ==  AuthorizePaymentType.Authorize_Only);
          let cart =  this.buildReservationRequest(true);
          // let isCardOnFileRequired = this.paymentData?.ResponseDTOs?.filter(response => response.IsCancellationFeeApplicable)?.length ? true:  false;
          const dto = {
            PartyId: this.activityService.successBookRes?.PartyId || this.activityService?.editData?.Id || null,
            SlotLockIds: [],
            BookingID: null,
            PayResponse : this.rGuestPayResponseData,
            TokenType: '',
            PaymentAmount: transInfo.paidAmount,
            PaymentGateway: this.paymentGateway,
            AuthorizeTransactions: this.transactions,
            ReservationAttemptIds: this.activityService.operation === operationType.edit ?
              this.paymentData?.AttemptIds || [this.paymentData.ReservationAttemptId] :
              reservationAttemptIds,
            SplitPaymentReload: this.isSplitPayment,
            CardOnFileRequired : (!!cart.find(f=> f.PaymentMethod == PaymentMethod.Authorize) &&  !isCreditcardPayment),
            CardOnFileAmount : this.TotalAmount - this.PayableAmount 
          };
          if(this.activityService.operation == operationType.create && this.paymentData?.ResponseDTOs[0]?.ReservationAttemptIds?.length > 0)
          {
             dto.ReservationAttemptIds = reservationAttemptIds;
          }
          this.creditCardPaid = true;
          // if(!dto.CardOnFileRequired && isCardOnFileRequired) {
          //   dto.CardOnFileRequired = isCardOnFileRequired;
          // }

          //Credit card authorization/payment has not occurred.
          //Only the credit card token has been collected.
          this.transactions.forEach(f=>
          {
            if(f.PaymentType ==  AuthorizePaymentType.CreditCardToken){
              dto.PaymentAmount -= f.Amount;
              f.Amount = 0;
            }
          });

          if(this.transactions.every(e=>e.PaymentType == AuthorizePaymentType.CreditCardToken)){
            this.reservationConfirm(true);
          }else{
            this.UpdateMultiCartReservationAttempt(dto);
          }

        } else {
          this.activityService.openSnackBar
            (this.ts.instant('CardInformationProcessNotCompleted'),
              this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
      }
      else {
        if (rGuestPayRespose.code && rGuestPayRespose.code !== '100') {
          rGuestPayRespose = JSON.parse(data);
          if (rGuestPayRespose.validationErrors && rGuestPayRespose.validationErrors.length > 0) {
            let errorString = '';
            rGuestPayRespose.validationErrors.forEach((error, i, arr) => {
              errorString = error.fieldName + ' ' + error.value + '\n';
            });
            this.activityService.openSnackBar(errorString, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
          }
          else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.message) {
            alert(rGuestPayRespose.gatewayResponseData.message);
          }
          else {
            this.activityService.openSnackBar(this.ts.instant('CardInformationProcessNotCompleted'),
              this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
          }
        }
        else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.code === '100') {
          const callbackDto = {
            ReservationAttemptIds: reservationAttemptIds,
            CardNumber: rGuestPayRespose.cardInfo.accountNumberMasked,
            ExpirationDate: new Date(data.cardInfo.expirationYearMonth.substring(0, 4) + '-' +
              data.cardInfo.expirationYearMonth.substring(4) + '-01'),
            CVC: '',
            FirstNameHolder: '',
            LastNameHolder: '',
            AddressLine1: '',
            AddressLine2: '',
            City: '',
            State: '',
            PostalCode: '',
            TokenType: '',
            Token: data.token
          };
          this.creditCardPaid = true;
          this.UpdateMultiCartReservationAttempt(callbackDto);
        }
        else {
          this.activityService.openSnackBar(this.ts.instant('CardInformationProcessNotCompleted'),
            this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
      }
    }
    else if (data.type === 'txn-completed' && data.transactionInfo) {

    } else {
      // Show Error Message
    }
  }

  preloadCartData() {
    // Taking 0th index restaurant details since merchant API does not support merchant level configuration for tems and currency
    this.operationCurrency = this.cartItems[0].SelectedActivityInfo.OperationCurrency;
    this.findPartySize();
    if (this.customTerms.length === 0) {
      if (!this.isEdit) {
        if(!this.activityService.DisableCustomTermsAndConditions) {
          this.basicTerm();
        }
        else {
          if(this.activityService.DisableCustomTermsAndConditions && this.cartItems[0].SelectedActivityInfo?.CustomTermsOfService?.length > 0 ) {
            this.validationMessageList.push(this.ts.instant('By click next, you agree to the following'));
            this.validationMessageList.push(`<a class="link-url" href="${this.activityService?.ConfigSettings?.termsUrl}" target="_blank">${this.ts.instant('termsOfUse')}</a>` + this.ts.instant('and') + `<a class="link-url" href="${this.activityService?.ConfigSettings?.privacyUrl}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`);
            const customTermsList = this.cartItems[0].SelectedActivityInfo.CustomTermsOfService;
            customTermsList.forEach((customTerms) => {
              this.validationMessageList.push(customTerms);
            })
          }
          else {
            this.validationMessageList.push(this.getAgreeTermsAndConditionsText());
          }
        }
        if (this.cartItems[0].SelectedActivityInfo?.CustomTermsOfService?.length > 0 && !this.activityService.DisableCustomTermsAndConditions) {
          const customTerms = this.cartItems[0].SelectedActivityInfo.CustomTermsOfService;
          this.processCustomTermsConditions(customTerms);
        }
      }
      this.processOtherCheckBoxes();
    }
  }

  applyDefaultGuestDetails(event) {
    this.applyToAllGuests = event.checked;
    if (this.applyToAllGuests) {
      this.processGuestAutoFill();
    }
  }

  processGuestAutoFill() {
    this.guestDetails.forEach((guest, i) => {
      if (i > 0) {
        guest.mobile = this.guestDetails[0].mobile;
        guest.email = this.guestDetails[0].email;
      }
    });
  }

  applyToOtherGuestDetails(guestIndex) {
    if (this.applyToAllGuests && guestIndex === 0) {
      this.processGuestAutoFill();
    }
  }

  addNewGuest() {
    this.guestDetails.push({
      firstName: '',
      lastName: '',
      email: '',
      mobile: ''
    });
    this.selectedAdditionalGuest = this.guestDetails.length - 1;
    if (this.applyToAllGuests) {
      this.processGuestAutoFill();
    }
  }

  removeAdditionalGuest(guestIndex) {
    this.guestDetails.splice(guestIndex, 1);
  }

  openCloseAdditionalGuest(i) {
    this.selectedAdditionalGuest = (i === this.selectedAdditionalGuest) ? 0 : i;
  }

  getPhoneCountryCodes() {
    const restaurantSettings = this.widgetSettings.DefaultMobileCountryCode;
    if (restaurantSettings) {
      this.activityService.GetCountries().subscribe(data => {
        if (data) {
          this.activityService.countriesList = data;
          this.dfs.countriesList = data;
          this.countryList = [];
          data.forEach(element => {
            this.countryList.push({ id: element.Id, value: element.CountryPhoneCode + '  (' + element.Name + ' )' });
          });
          if (data && data.length > 0) {
            const countrySelected = Utilities.getDefaultCountry(data, restaurantSettings);
            this.countryList = [];
            data.forEach(element => {
              this.countryList.push({ id: element.Id, value: element.CountryPhoneCode + '  (' + element.Name + ' )' });
            });
            this.guestDetails[0].countryId = this.activityService.selectedCountryId ?
              this.activityService.selectedCountryId : (this.isEdit ? this.guestDetails[0].countryId : (countrySelected.Id));
          }
        }
      });
    } else { this.guestDetails[0].countryId = 1; }
  }

  isValidURL(val) {
    const res = val.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null);
  }

  processCustomTermsConditions(termsarray) {
    // "please [Terms & Conditions | https://www.google.com] "] shd be in this format

    termsarray.forEach((terms, i) => {
        this.customTerms.push({ labelText: terms, labelValue: false, name: `customTerm_${i}`, required: true });
    });
  }

  basicTerm() {
    if (this.activityService?.ConfigSettings?.termsUrl && this.activityService?.ConfigSettings?.privacyUrl) {
      this.customTerms.push({ labelText: this.getAgreeTermsAndConditionsText(), labelValue: false, name: 'agreeTerms', required: true });
    }
  }

  checkSubmitValidation() {
    let disableSubmit = !this.guestDetailsForm?.valid || (!this.isEdit && this.checkBoxErrorMessages) || (this.waiverForm && !this.isUserAllowedToclickConfirm ) || (this.activityService?.reservationAttemptInfo?.CreditCardIframeUrl && !this.creditCardPaid && this.activityService?.reservationAttemptInfo?.ShouldCreditCardBeEntered) || (this.financialData?.RedirectUrl && !this.creditCardPaid) || this.showCartLockWarning || this.paymentOffline
    this.disableSubmitButton  = disableSubmit;
  }
  checkTermsValidation() {
    let validTerms = true;
    this.customTerms.forEach(terms => {
      if (terms.required && (terms.required !== terms.labelValue)) {
        validTerms = false;
      }
    });
    return validTerms;
  }

  saveCardInfo(){

  }

  processOtherCheckBoxes() {
    this.reminderSmsEmailChecks = [];
    if (this.cartItems[0]?.SelectedActivityInfo.IsSmsReminderSupported) {
      if (this.cartItems[0]?.SelectedActivityInfo.IsReservationReminderMandatory) {
        this.reminderSmsEmailChecks.push(
          { labelText: this.ts.instant('SmsMessageReminderText'), labelValue: true, name: 'reservationBySMS', disabled: true });
      } else {
        this.reminderSmsEmailChecks.push(
          { labelText: this.ts.instant('SmsMessageReminderText'), labelValue: false, name: 'reservationBySMS' });
      }
    }
    this.reminderSmsEmailChecks.push({
      labelText: this.ts.instant('emailReminderText'), labelValue: false, name: 'reservationByEmail', required: true
    });
    if (this.cartItems[0]?.SelectedActivityInfo.ConfirmationVia === ConfirmationVia.Both) {
      this.reminderSmsEmailChecks.push(
        { labelText: this.ts.instant('smsConfirmationText'), labelValue: false, name: 'reservationConfirmationBySMS' });
      this.reminderSmsEmailChecks.push(
        { labelText: this.ts.instant('emailConfirmationText'), labelValue: false, name: 'reservationConfirmationByEmail' });
    }
  }

  getAgreeTermsAndConditionsText(): string {
    let text = '';
    if(this.activityService.DisableCustomTermsAndConditions ){
      text = this.ts.instant('By clicking next, you agree to the terms of use and privacyPolicy', {terms: `<a class="link-url" href="${this.activityService?.ConfigSettings?.termsUrl}" target="_blank">${this.ts.instant('termsOfUse')}</a>`, privacyPolicy: `<a class="link-url" href="${this.activityService?.ConfigSettings?.privacyUrl}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`})
    }else{
      text = this.ts.instant('You agree to the terms of use and privacyPolicy', {terms: `<a class="link-url" href="${this.activityService?.ConfigSettings?.termsUrl}" target="_blank">${this.ts.instant('termsOfUse')}</a>`, privacyPolicy: `<a class="link-url" href="${this.activityService?.ConfigSettings?.privacyUrl}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`})
    }
    // text = `${this.ts.instant('agree')}<a class="link-url" href="${this.activityService?.ConfigSettings?.termsUrl}" target="_blank">${this.ts.instant('termsOfUse')}</a>${this.ts.instant('and')}
    //  <a class="link-url" href="${this.activityService?.ConfigSettings?.privacyUrl}" target="_blank" >${this.ts.instant('privacyPolicy')}</a>`;
    return text;
  }

  ngOnInit(): void {
    let restaurantId = this.activityService.isDining ? this.activityService.selectedDining.RestaurantId : this.activityService.isNonDining ? this.activityService.selectedNonDining.RestaurantId : this.activityService.selectedActivities.RestaurantId;
    if(!restaurantId && !this.activityService.widgetSettings.PropertyWidgetSettings){
      this.activityService.navigateToHome();
    }
    this.restaurantData = this.activityService.widgetSettings.PropertyWidgetSettings.find(property => property.RestaurantId == restaurantId);
    this.balanceAmount = 0;
    this.financialEffectId = 0;
    this.customTerms = [];
    this.enableSubmit = false;
    this.activityService.operation = window.location.pathname.split('/').indexOf('edit') !== -1 ? operationType.edit : operationType.create;
    this.isEdit = this.activityService.operation === operationType.edit ? true : false;
    this.activityService.hideCart.next(true);
    this.activityService.startTimer();
    let cartList = JSON.parse(sessionStorage.getItem('CartList_' + this.activityService.restaurantMerchantCode));
    if(cartList?.length){
      this.taxTypeForBooking = this.activityService.widgetSettings.PropertyWidgetSettings.find((property) => property.RestaurantId == cartList[0].PropertyId).TaxType;
    }
    if(!this.activityService.mealWithConfig)
    this.activityService.showBackNav();
    this.activityService.currentNavURL = 'order-summary';
    this.activityService.prevNavURL = 'slot-selection/' + this.activityService.restaurantWidgetId;
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
    this.widgetSettings = this.activityService.
      getSessionData('rGuestActivitesWidgetSettings_' + this.activityService.restaurantMerchantCode, true);
    this.activityService.getWidgetImagesMerchantLevel(this.widgetSettings.MerchantId);
    this.cartItems = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true) || [];
    if (this.cartItems?.length === 0 || this.widgetSettings.MerchantCode !== this.activityService.restaurantMerchantCode) { // if cart length avaiallbe set cartItems
      this.activityService.navigateToUrl('list');
    }
    if (this.isEdit) {
      this.activityService.restaurantWidgetId = this.route.snapshot.params.restaurantId;
    }
    if (Object.keys(this.activityService?.editData)?.length === 0 && this.activityService.getSessionData('activityEditData_' + this.activityService.restaurantMerchantCode)) {
      this.activityService.editData = this.activityService.getSessionData('activityEditData_' + this.activityService.restaurantMerchantCode, true);
    }
    if (this.guestDetails.length === 0) {
      this.addNewGuest();
    }
    this.getPhoneCountryCodes();

    this.cartItems.forEach(element => {
      if(!this.showCardOnFileInformation){
        this.showCardOnFileInformation = this.isCardOnFilePayment(element.SpecialMealId,element.PropertyId);
      }else{
        return;
      }
    });

  }

  ngAfterViewInit() {
    this.activityService.DisableCustomTermsAndConditions = this.activityService.widgetSettings?.PropertyWidgetSettings?.every(({DisableCustomTermsAndConditions}) => DisableCustomTermsAndConditions);

    if(!this.activityService.DisableCustomTermsAndConditions) {
      this.isValidateTerms = true;
    }
    this.isEdit ? this.setEditData(true) : this.RegisterReservationMerchantLevelAttempt(true);
    this.preloadCartData();
    this.checkCustomTermsAndMessageOptionValidation();
  }
  setEditData(initial = true) {
    if (Object.keys(this.activityService?.editData)?.length && this.guestDetails?.length) {
      this.guestDetails[0].firstName = this.activityService?.editData?.Contact?.FirstName;
      this.guestDetails[0].lastName = this.activityService?.editData?.Contact?.LastName;
      this.guestDetails[0].mobile = this.activityService?.editData?.Contact?.PhoneNumber;
      this.guestDetails[0].email = this.activityService?.editData?.Contact?.EmailAddress;
      this.guestDetails[0].countryId = this.activityService?.editData?.Contact?.CountryId;
    }
    // this.RegisterReservationMerchantLevelAttempt(true);
    this.setRatePlanCalculation(initial);
  }

  setRatePlanCalculation(initial) {
    const cartObj = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true) || [];
    const cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true) || [];
    this.showCartLockWarning = true;
    if (cartLockList.length == cartLockList.filter(x => x.isAvailable).length) {
      this.showCartLockWarning = false;
    }
    const multiRegPayload = [];
    if (cartObj && cartObj.length > 0) {
      cartObj.forEach(eachActivities => {
        let coverTypeTotal = 0;
        if (eachActivities?.CoverTypes?.length) {
      eachActivities?.CoverTypes.forEach(coverType => {
        coverTypeTotal += coverType.Covers;
      });
    }
    else {
      coverTypeTotal = eachActivities?.Size || 0;
    }
        const registerReservationAttemptRequestDTO = {
          Slots: eachActivities?.isNonDining ? eachActivities.Slots : eachActivities.isDining && !eachActivities.SpecialMealId ? [{LocalTime : eachActivities.Slot.Time}] : [],
          ActivityId: eachActivities?.SpecialMealId,
          GuestTypes: eachActivities?.CoverTypes,
          BookingTypes: eachActivities?.BookingTypes,
          Size: coverTypeTotal == eachActivities?.Size ? eachActivities?.Size : coverTypeTotal,
          SessionSlot: eachActivities?.Sessions,
          BookingBehavior: eachActivities?.BookingBehavior,
          CoverTypes: eachActivities?.CoverTypes,
          TableIds: eachActivities?.isNonDining ? eachActivities?.TableIds : eachActivities?.TableId,
          RestaurantId: +eachActivities?.PropertyId,
          DoesRequirePrepayment: eachActivities?.DoesRequirePrepayment,
          IsCommunalTable: this.activityService.isDining || eachActivities?.isNonDining ? eachActivities?.IsCommunalTable : null,
          LocalTime: this.activityService.isDining ? eachActivities?.LocalTime : null,
          SeatingAreaId: this.activityService.isDining || eachActivities?.isNonDining ? eachActivities?.SeatingArea : null,
          SeatingTypeId: this.activityService.isDining || eachActivities?.isNonDining ? eachActivities?.SeatingType : null,
          TableId: this.activityService.isDining ? eachActivities?.TableId : null,
          AddOns: eachActivities?.isNonDining ? eachActivities?.AddOns : eachActivities?.AddOns,
          StartDate: eachActivities?.StartDate || null,
          EndDate: eachActivities?.EndDate || null,
          Contact:this.activityService?.editData?.Contact || null,
          BookingContacts : this.activityService?.editData?.BookingContacts || null,
          PartyId:this.activityService?.editData?.Id || null
        };

        multiRegPayload.push(registerReservationAttemptRequestDTO);
      });
    }

    const request = multiRegPayload[0];
    let cartId = cartObj[0].CartId;    

    if (this.activityService.isDining) {
      this.RegisterReservationAttemptEdit(true, true, request);
    } else {
      this.activityService.startLoader();
      // this.subscriptions.add(
      this.activityService.GetSessionRatePlanCalculated(request).subscribe(response => {
        this.activityService.stopLoader();

        const multiCartRegisterResponse = response?.Payload.RatePlan.Reservations || [];
        // const multiCartRegisterResponse = response?.Payload.RatePlanCalculations || [];
        if (multiCartRegisterResponse.length > 0) {
          multiCartRegisterResponse[0].CartId = cartId;
          this.totalActivitiesRegistered = this.processOrderSummatyList(multiCartRegisterResponse,
            request.GuestTypes,
            request.BookingTypes,
            request.Size,
            response);
            this.financialEffectId = response.Payload.FinancialEffectId;
          console.log(this.totalActivitiesRegistered);
        }
        else {
          this.totalActivitiesRegistered.push(this.formOrderSummaryForNoRatePlanBookings(request));

        }
        //this.RegisterReservationAttemptEdit(true, true, request);
        this.invokeFinancialEffect(request,true);
      }, () => {
        this.activityService.stopLoader();
      });
    }
    // );
  }
  invokeFinancialEffect(request,isIframeToBeDisplayed){
    if (this.activityService.operation === operationType.edit &&
      Object.keys(this.activityService.editData)?.length && this.activityService.editData?.Id ) {

      this.activityService.isDining 
      ? this.getFinancialEffectCalculation() 
      : this.UpdateActivityFinancialEffect(request,isIframeToBeDisplayed);
    }}

    UpdateActivityFinancialEffect(request,isIframeToBeDisplayed){
      
      const bookingData = {
        Slots: request?.Slots || [],
        ActivityId: request?.ActivityId,
        CoverTypes: request?.CoverTypes,
        BookingTypes: request?.BookingTypes,
        Size: +request?.Size,
        SessionSlot: request?.SessionSlot,
        BookingBehavior: request?.BookingBehavior,
        TableIds: request?.TableIds,
        RestaurantId: +request?.RestaurantId,
        PartyId: this.activityService?.editData?.Id || null,
        Sessions: request?.SessionSlot,
        InstructorIds: [],
        FromWebsite: true,
        IsCommunalTable: this.activityService.isDining ? request?.IsCommunalTable : null,
        LocalTime: this.activityService.isDining ? request?.LocalTime : null,
        SeatingAreaId: this.activityService.isDining ? request?.SeatingArea : null,
        SeatingTypeId: this.activityService.isDining ? request?.SeatingType : null,
        TableId: this.activityService.isDining ? request?.TableIds : null,
        AddOns: request?.AddOns,
        Contact: request?.Contact,
        BookingContacts: request?.BookingContacts,
      };
  
      let payload ={
        "PropertyId": +request?.RestaurantId,
        "ReservationId": this.activityService?.editData?.Id || null,
        "Source": 1,
        "BookAttemptRequest": bookingData,
      }
      this.activityService.startLoader();
      this.activityService.UpdateReservationFinancialEffect(payload).subscribe((response: any) => {
        this.updateBookingForFinancialEffect(response.Payload)
      }, error => {
        this.activityService.stopLoader();
      });
      this.checkSubmitValidation();
    }

    updateBookingForFinancialEffect(data){
      this.activityService.stopLoader();
      data.PaymentAmount = data.Amount;
      
      let bookings = [];
      data.RatePlan?.Reservations?.forEach((eachItem) => {
        eachItem.Sessions.forEach(session => {
          bookings.push({
            Items: session.GuestPrices[0].Items,
            date: session.Date,
            SubTotal: session.SubTotal,
            Total: session.Total,
            TimeRange: session.TimeRange,
            ActivityName: this.isEdit ? (this.activityService.editData?.SpecialMealName || '') : data?.ActivityName ? data.ActivityName : this.restaurantData?.RestaurantName || null,
            Size: data.Size ? data.Size : this.guestPartySize,
            WidgetPrePaymentMode: null,
            ServiceCharge: session.ServiceCharge,
            ServiceCharges: session.ServiceCharges,
            VAT: session.VAT,
            Tax: session.Tax,
            Taxes: session.Taxes,
            NoShowFeeAmount: eachItem.NoShowFeeAmount
          })
        })
      })
      this.overallBookings = bookings;
      this.activityService.stopLoader();
      if (data) {
        this.financialData = data;
        if (data.PaymentGateway) {
          this.paymentGateway = data.PaymentGateway;
        }
        this.financialEffectId = data.FinancialEffectId;
        this.paymentData = this.activityService.reservationAttemptInfo = data;
        if(data.RatePlan.SubTotal > 0) {
        this.paymentData.SubTotal = data.RatePlan.SubTotal;
        this.paymentData.ServiceCharge = data.RatePlan.ServiceCharge;
        this.paymentData.ServiceCharges = data.RatePlan.ServiceCharges;
        this.paymentData.TaxOnServiceChargeAmount = data.RatePlan.TaxOnServiceChargeAmount;
        this.paymentData.Tax = data.RatePlan.Tax;
        this.paymentData.Taxes = data.RatePlan.Taxes;
        this.TotalAmount = data.RatePlan.Total;
          this.PayableAmount = data.RatePlan.Unpaid;
        }
        // this.paymentData.ReservationAttemptId = data.RatePlan?.Reservations?.length ? data.RatePlan?.Reservations[0]?.ReservationAttemptId : null;
        if (data.RedirectUrl) {
          this.isSplitPayment = false;
          this.isUserAllowedToclickConfirm = false;
          // this.confirmButton.disbaledproperity = true;
          this.LoadIframe(data.RedirectUrl);
        } // else {
        switch (data.PartyPaymentType) {
          case 0: // NotSupported
            this.activityService.setMessageState(this.ts.instant('ReservationBetweenLocationPrePaidNotSupported'), 0);
            this.isUserAllowedToclickConfirm = false;
            // this.confirmButton.disbaledproperity = true;
            return;
            break;
          case 1: // NoPaymentsInvolved
            // No messaging in this case
            break;
          case 2: // NoEffect
            if(data.RetailCreditCardPaymentTokenId){
              this.infoMessage = this.ts.instant('SavedCardInfoMessageForCharge');
            }else{
              this.showFinancialEffectPopUp(this.ts.instant('NoChargeOrRefundForThisReservation'));
            }
            break;
          case 3: // NewReservationAttempt
            // paymentIframeRequired = true;
            if (this.isSelectedMealDefferedPayment()) {
              this.popUpMessage = this.ts.instant('yourCardWillBeChargedPriorToYourMealTime');
            } else {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 4: // NoFullRefund
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('NoChargeOrRefundForThisReservation');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 5: // FullRefund
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' '
              + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 6: // NoFullRefundAndNewReservationAttempt
            if (data.PaymentAmount != null && (data.PaymentAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('noRefundMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 7: // FullRefundAndNewReservationAttempt
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' '
              + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 8: // PartialCharge
            if (this.activityService.reservationAttemptInfo?.ShouldCreditCardBeEntered) {
              this.popUpMessage = this.ts.instant('CardNeededToUpdateThisReservation') + ' '
                + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('enterCreditCard');
            }
            else {
              this.popUpMessage = this.ts.instant('CardUsedForTheOriginalBookingWillCharged') + ' '
                + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 9:
          case 14: // PartialRefund       
            this.refundAmount = true;
            if (this.financialData.RefundOption && this.financialData.RefundOption.length > 0) {
              // this.popUpMessage = this.ts.instant('Refund request of ') +
              // this.operationCurrency + data.PaymentAmount + this.ts.instant(' has been initiated');
              this.popUpMessage = this.ts.instant('refundRequestOf') + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + this.ts.instant('hasBeenProcessed');
            } else {
              this.popUpMessage = this.ts.instant('refundMessage') + this.operationCurrency + Math.abs(data.PaymentAmount).toFixed(this.widgetSettings.NumberOfFractionalDigits) + '.<br />'
                + this.ts.instant('severalDaysMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 10: // NoShowFeeUpdated
            this.popUpMessage = this.ts.instant('IfDonotShowYouWillBeCharged') + ' ' +
              this.operationCurrency +data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 11: // Authorize

            if (data.PaymentAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' +
                this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
          case 12: // Authorize updated

            if (data.PaymentAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' +
                this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
        }
        if (this.isEdit && this.activityService.isDining && this.activityService.selectedSpecialMeal) {
          this.totalActivitiesRegistered = this.processEditOrderSummaryList(data);
        }
        // this.bindPaymentAmountAndMessage(data.RatePlanAmount, data.SpecialMealAmount, data.TotalAmount)
        // need to check how to find deferred payment mode
        if (this.activityService.reservationAttemptInfo?.ShouldCreditCardBeEntered) {
          this.isUserAllowedToclickConfirm = false;
          // this.confirmButton.disbaledproperity = true;
          this.LoadIframe(this.activityService.reservationAttemptInfo?.CreditCardIframeUrl);
        }
        else {
          if (!data.RedirectUrl) {
            this.isUserAllowedToclickConfirm = true;
            // this.confirmButton.disbaledproperity =
            //  this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationVia == ConfirmationVia.Both;
          }
        }
        // }
      }
      setTimeout(() => {
        this.checkSubmitValidation();
      }, 200)
    }

  RegisterReservationAttemptEdit(isIframeToBeDisplayed: boolean, fromEdit = false, request) {
    const registerReservationAttemptRequestDTO = {
      Slots: request?.Slots || [],
      ActivityId: request?.ActivityId,
      CoverTypes: request?.CoverTypes,
      BookingTypes: request?.BookingTypes,
      Size: +request?.Size,
      SessionSlot: request?.SessionSlot,
      BookingBehavior: request?.BookingBehavior,
      TableIds: request?.TableIds,
      RestaurantId: +request?.RestaurantId,
      PartyId: this.activityService?.editData?.Id || null,
      Sessions: request?.SessionSlot,
      InstructorIds: [],
      FromWebsite: true,
      IsCommunalTable: this.activityService.isDining ? request?.IsCommunalTable : null,
      LocalTime: this.activityService.isDining ? request?.LocalTime : null,
      SeatingAreaId: this.activityService.isDining ? request?.SeatingArea : null,
      SeatingTypeId: this.activityService.isDining ? request?.SeatingType : null,
      TableId: this.activityService.isDining ? request?.TableIds : null,
      AddOns: request?.AddOns
    };

    if (registerReservationAttemptRequestDTO.BookingBehavior === BookingBehavior.ClassOrSession) {
      registerReservationAttemptRequestDTO.Slots = [];
    }
    else {
      registerReservationAttemptRequestDTO.Sessions = null;
    }

    this.activityService.startLoader();
    this.activityService.RegisterReservationAttempt(registerReservationAttemptRequestDTO, this.activityService.isDining).subscribe((response: any) => {
      this.activityService.stopLoader();
      this.updateBooking(response,isIframeToBeDisplayed)
     }, error => {
      this.activityService.stopLoader();
    });

  }


  updateBooking(response,isIframeToBeDisplayed){
    if (response) {
      this.checkCustomTermsAndMessageOptionValidation();
      this.paymentData = this.activityService.reservationAttemptInfo = response;
      this.paymentGateway = response.PaymentGateway;
      this.TotalAmount = response.PaymentAmount;
      this.PayableAmount = response.PayableAmount;
      if (response.ShouldCreditCardBeEntered && isIframeToBeDisplayed) {
        if (this.activityService.reservationAttemptInfo?.CreditCardIframeUrl) {
          this.LoadIframe(this.activityService.reservationAttemptInfo?.CreditCardIframeUrl);
          this.paymentOffline = false;
        }
        else {
          this.paymentOffline = true;
          this.activityService.openSnackBar(
            this.ts.instant('SorryForPaymentOffline'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');


            

        }
      }
      if (this.activityService.operation === operationType.edit &&
        Object.keys(this.activityService.editData)?.length && this.activityService.editData?.Id) {
        this.getFinancialEffectCalculation();
      }
    }
  }

  processOrderSummatyList(multiCartRegisterResponse, GuestTypes, BookingTypes, Size, response) {

    console.log(multiCartRegisterResponse);
    multiCartRegisterResponse = this.setCartItemForIndividualSessions(multiCartRegisterResponse);
    console.log(GuestTypes);
    this.subTotal = 0;

    return multiCartRegisterResponse.map((eachRegisterResponse, respIndex) => {
      let argGuestTypes = [];
      let argBookingTypes = [];
      let argSize = 1;

      const eachGuestTypes = this.activityService.findRegistrationAttemptArrayData(GuestTypes, eachRegisterResponse.CartId || GuestTypes[respIndex]?.CartId);

      if (!this.isEdit) {
        argGuestTypes = eachGuestTypes.CoverTypes;
        argBookingTypes = eachGuestTypes.BookingTypes;
        argSize = eachGuestTypes.PartySize;
      } else {
        argGuestTypes = GuestTypes;
        argBookingTypes = BookingTypes;
        argSize = Size;
      }
      if(eachGuestTypes.isDining && eachGuestTypes.SpecialMealId) {
        if (eachRegisterResponse) {
          eachRegisterResponse = this.formDiningOrderList(eachRegisterResponse,
            eachGuestTypes,
            +argSize,
            eachGuestTypes?.SpecialMealName,
            eachRegisterResponse?.RateplanAmountinfo,
            eachRegisterResponse?.SpecialMealAmountinfo);
        }
      }
      else {
        console.log(GuestTypes, BookingTypes, Size);
        if (eachRegisterResponse) {
          let reconstructRatePlan: any;
          if (this.isEdit) {
            reconstructRatePlan = eachRegisterResponse;
          } else if (eachRegisterResponse.RatePlanTotal) {
            reconstructRatePlan = eachRegisterResponse?.RatePlanTotal.RatePlanCalculations[0];
          }
          if (reconstructRatePlan) {
            eachRegisterResponse.TimeRange = reconstructRatePlan.TimeRange;
            eachRegisterResponse.PaymentAmount = (reconstructRatePlan.TotalAmount + reconstructRatePlan.TotalAddOnAmount)
            eachRegisterResponse.AddonAttemptDetails = reconstructRatePlan.AddonAttemptDetails;
            eachRegisterResponse.TotalAddonAmount = reconstructRatePlan.TotalAddOnAmount;
            if (reconstructRatePlan?.RatePlanVariants?.GuestTypeVariant?.length) {
              eachRegisterResponse.MinRateAdjustmentAmount = _.sumBy(reconstructRatePlan.RatePlanVariants.GuestTypeVariant, 'MinCoverRateAdjustment');
            } else {
              eachRegisterResponse.MinRateAdjustmentAmount = 0;
            }
              
            eachRegisterResponse.SlotList =
            eachRegisterResponse.LocationVariant = reconstructRatePlan?.RatePlanVariants?.OriginalLocationVariant;
            eachRegisterResponse.LocationAmount = reconstructRatePlan?.RatePlanVariants?.LocationVariant;
            eachRegisterResponse.InstructorVariant = reconstructRatePlan?.RatePlanVariants?.OriginalInstructorVariant;
            eachRegisterResponse.InstructorAmount = reconstructRatePlan?.RatePlanVariants?.InstructorVariant;
            eachRegisterResponse.BaseVariant = reconstructRatePlan?.RatePlanVariants?.OriginalBaseRate;
            eachRegisterResponse.BaseAmount = reconstructRatePlan?.RatePlanVariants?.TotalBaseRate;
              eachRegisterResponse.coverTypeVariants = reconstructRatePlan?.RatePlanVariants?.GuestTypeVariant ?
                reconstructRatePlan.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
                  const guestType = argGuestTypes?.
                    find(coverType => coverType.CoverTypeId === coverVariant.CoverTypeId);
                  coverVariant.CoverTypeName = guestType && guestType?.Name ? guestType.Name : '';
                  coverVariant.coverTotal = (reconstructRatePlan.RatePlanVariants.TotalBaseRate / +argSize) * coverVariant.covers + coverVariant.Variant;
                  coverVariant.defaultPrice = coverVariant.coverTotal / coverVariant.covers;
                  coverVariant.coverTotal =
                    // (((reconstructRatePlan.RatePlanVariants.TotalBaseRate / +argSize) +
                    //   (reconstructRatePlan.RatePlanVariants.InstructorVariant / +argSize) +
                    //   (reconstructRatePlan.RatePlanVariants.LocationVariant / +argSize)) *
                    //   coverVariant.covers) +
                       coverVariant.Variant;
                  coverVariant.defaultPrice = coverVariant.OriginalVariant;
                  return coverVariant;
                }).filter(bookingTypeVariant => bookingTypeVariant.covers) : [];
            eachRegisterResponse.bookingTypeVariants = reconstructRatePlan?.RatePlanVariants?.BookingTypeVariant ?
              reconstructRatePlan.RatePlanVariants.BookingTypeVariant?.map(bookingTypeVariant => {
                bookingTypeVariant.BookingTypeName = argBookingTypes?.
                  find(bookingType => bookingType.BookingTypeId === bookingTypeVariant.BookingTypeId)?.Name;
                bookingTypeVariant.bookingTotal = (reconstructRatePlan.RatePlanVariants.TotalBaseRate / +argSize) * bookingTypeVariant.bookingTypes  + bookingTypeVariant.Variant;
                bookingTypeVariant.defaultPrice = bookingTypeVariant.bookingTotal / bookingTypeVariant.bookingTypes;
                return bookingTypeVariant;
              }).filter(bookingTypeVariant => bookingTypeVariant.bookingTypes) : [];
              
              eachRegisterResponse.locationTypeVariants = reconstructRatePlan?.RatePlanVariants?.LocationVariant ?
              reconstructRatePlan.RatePlanVariants.LocationVariant?.map(locationTypeVariant => {
                locationTypeVariant.LocationName = eachGuestTypes.isDining ?(this.restaurantData.SeatingTypeList?.find(type => type.Id == locationTypeVariant?.SeatingTypeId)?.Description ) : this.ts.instant('location');
                locationTypeVariant.locationTotal = locationTypeVariant.Variant;
                locationTypeVariant.Count = locationTypeVariant.Count;
                locationTypeVariant.defaultPrice = locationTypeVariant.locationTotal / locationTypeVariant.Count;
                return locationTypeVariant;
              }).filter(bookingTypeVariant => bookingTypeVariant.Count) : [];

              if (eachRegisterResponse?.RatePlanTotal?.SpecialMealVariant && eachRegisterResponse?.RatePlanTotal?.SpecialMealVariant.SpecialMealAmount > 0) {
                eachRegisterResponse.coverTypeVariants = eachRegisterResponse.RatePlanTotal.SpecialMealVariant.GuestTypeVariants?.map(coverVariant => {
                  const guestType = argGuestTypes?.find(coverType => coverType.CoverTypeId === coverVariant.CoverTypeId);
                  coverVariant.CoverTypeName = guestType && guestType?.Name ? guestType.Name : '';
                  coverVariant.coverTotal = coverVariant.OriginalVariant * coverVariant.covers;
                  coverVariant.defaultPrice = coverVariant.OriginalVariant;
                  return coverVariant;
                }).filter(bookingTypeVariant => bookingTypeVariant.covers);


                reconstructRatePlan.RatePlanVariants.LocationVariant?.map(locationTypeVariant => {
                  locationTypeVariant.LocationName = eachGuestTypes.isDining ?(this.restaurantData.SeatingTypeList?.find(type => type.Id == locationTypeVariant?.SeatingTypeId)?.Description ) : this.ts.instant('location');
                  locationTypeVariant.locationTotal = (locationTypeVariant.Variant + reconstructRatePlan.RatePlanVariants.OriginalBaseRate )* locationTypeVariant.Count ;
                  locationTypeVariant.Count = locationTypeVariant.Count;
                  locationTypeVariant.defaultPrice = locationTypeVariant.Variant + reconstructRatePlan.RatePlanVariants.OriginalBaseRate;
                  return locationTypeVariant;
                })
              }
            eachRegisterResponse.TotalAmount = reconstructRatePlan.TotalAmount;
            this.subTotal += (reconstructRatePlan.TotalAmount + reconstructRatePlan.TotalAddOnAmount);
          }
          else {
            eachRegisterResponse = this.formOrderSummaryForNoRatePlanBookings(eachRegisterResponse)
          }
        } else {
          eachRegisterResponse.SlotList = response?.Slots;
        }
      
      }
      // common bindings for dining and non-dining
      eachRegisterResponse.Size = argSize;
      eachRegisterResponse.isDining = eachGuestTypes.isDining;
      eachRegisterResponse.isNonDining = eachGuestTypes.isNonDining;
      let cartItems = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
      let cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
      let cartItem = cartItems.find(item => item.CartId === eachRegisterResponse.CartId);
      if(!cartItem){
         cartItem = cartItems.find(item => item.CartId === eachRegisterResponse.LockCartId);
      }
      let cartLockItem = cartLockList.find(item => item.CartId === eachRegisterResponse.LockCartId);
      eachRegisterResponse.SelectedActivityInfo = cartItem?.SelectedActivityInfo;
      if(cartLockItem?.ActivityId){
        eachRegisterResponse.WidgetPrePaymentMode = this.activitiesDataDic.Property[cartLockItem.propertyId].Activity[cartLockItem.ActivityId].WidgetPrePaymentMode;
      }else{
        eachRegisterResponse.WidgetPrePaymentMode = this.activitiesDataDic.Property[cartLockItem.propertyId].WidgetPrePaymentMode;
      }
      eachRegisterResponse.isAvailable = cartLockItem?.isAvailable;
      // if (!this.restaurantData) {
        eachRegisterResponse.restaurantData = this.activityService?.widgetSettings?.PropertyWidgetSettings?.find(property => property.RestaurantId == eachRegisterResponse.PropertyId);
      // }
      return eachRegisterResponse;
    });
  }
  setCartItemForIndividualSessions(cartItems) {
    this.totalServiceCharge = 0;
    let individual = [];
    let cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
    let newCartItems = _.cloneDeep(cartItems)
    newCartItems?.forEach((item, index) => {
      this.totalTax = this.totalTax + (item.RatePlanTotal?.MinRateAdjustment?.TaxAmount || 0) + (item.RatePlanTotal?.TotalAddonTaxAmount || 0)
      this.totalServiceCharge = this.totalServiceCharge + (item.RatePlanTotal?.TotalServiceChargeAmount || 0) + (item.RatePlanTotal?.MinRateAdjustment?.ServiceChargeAmount || 0) + (item.RatePlanTotal?.TotalAddonServiceChargeAmount || 0);
      this.taxOnServiceCharge = this.taxOnServiceCharge + (item.RatePlanTotal?.TotalTaxOnServiceChargeAmount || 0) +  (item.RatePlanTotal?.MinRateAdjustment?.TaxOnServiceChargeAmount || 0) + (item.RatePlanTotal?.TotalAddonTaxOnServiceChargeAmount || 0);
      if (item?.RatePlanTotal?.RatePlanCalculations) {
        item.RatePlanTotal.RatePlanCalculations.forEach(ratePlan => {
          let summary = _.cloneDeep(cartItems);
          let session = summary[index];
          session.RatePlanTotal.RatePlanCalculations = [ratePlan]
          session.LockCartId = cartLockList[index]?.CartId;
          individual.push(session);
        })
      } else {
        let summary = _.cloneDeep(cartItems);
        let session = summary[index];
        session.LockCartId = cartLockList[index]?.CartId;
        individual.push(session);
      }

    })
    return individual || [];
  }
  formDiningOrderList(registerResponse, diningDetails, size, specialMealName, ratePlanAmount, specialMealAmount, noShowFeeAmount?) {
    registerResponse.bookingTypeVariants = [];
    registerResponse.LocalTime = diningDetails.LocalTime;
    if (!ratePlanAmount && !specialMealAmount && (registerResponse.PaymentAmount > 0 || noShowFeeAmount)) {
      registerResponse.coverTypeVariants = [{
        CoverTypeName: this.ts.instant('noShowFee') + ' ' + this.ts.instant('authorizedFee'),
        covers: size,
        defaultPrice: registerResponse.PaymentAmount || noShowFeeAmount,
        coverTotal: registerResponse.PaymentAmount || noShowFeeAmount
      }];
    } else if (diningDetails?.CoverTypes && diningDetails.CoverTypes.length > 0) {
      registerResponse.coverTypeVariants = diningDetails.CoverTypes ? diningDetails.CoverTypes.map(cover => {
        return {
          CoverTypeName: (specialMealName ? (specialMealName + ' - ') : '') + cover.Name + (registerResponse?.IsImmediatePaymentMode === false && specialMealName ? (' ' + this.ts.instant('authorizedFee')) : ''),
          covers: cover.Covers,
          defaultPrice: diningDetails.DoesRequirePrepayment ? cover.Price : 0,
          coverTotal: diningDetails.DoesRequirePrepayment ? cover.Covers * cover.Price : 0
        }
      }).filter(coverType => coverType.covers !== 0) : [];
    } else if (diningDetails?.CoverTypes.length === 0 && specialMealName && size > 0) {
      registerResponse.coverTypeVariants = [{
        CoverTypeName: specialMealName,
        covers: size,
        defaultPrice: diningDetails.DoesRequirePrepayment ? diningDetails.Price : 0,
        coverTotal: diningDetails.DoesRequirePrepayment ? diningDetails.Price * size : 0
      }];
    } else {
      registerResponse.coverTypeVariants = [];
    }
    registerResponse.TotalAmount = (ratePlanAmount ? ratePlanAmount : 0) + (specialMealAmount ? specialMealAmount : 0);
    registerResponse.FormattedLocalTime = moment(new Date(diningDetails.LocalTime)).format('YYYY-MM-DDTHH:mm:ss');
    return registerResponse;
  }

  formOrderSummaryForNoRatePlanBookings(eachRegisterResponse) {
    let object = {};
    const cartList = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true) || [];
    let cartObj = null;
    if (!this.isEdit) {
      cartObj = cartList.find(cartData => eachRegisterResponse.CartId == cartData.CartId);
      object = eachRegisterResponse;
    }
    else {
      cartObj = cartList.find(cartData => eachRegisterResponse.Id == cartData.ActivityId);
      object['Size'] = eachRegisterResponse.Size;
      object['BookingTypes'] = eachRegisterResponse.BookingTypes;
      object['SelectedActivityInfo'] = cartObj.SelectedActivityInfo;
    }

    object['TimeRange'] = {
      End: cartObj?.SelectedTimeSlots?.[0].End,
      Start: cartObj.SelectedTimeSlots?.[0].Start
    }
    let cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
    let cartLock = cartLockList.find(cartData => eachRegisterResponse.ActivityId == cartData.ActivityId);
    if (cartLock) {
      object['isAvailable'] = cartLock?.isAvailable;
    }
    return object;
  }

  deleteCartItem(cartIndex, event: Event) {
    event.stopPropagation();
    this.unLockMultiCart(cartIndex);
  }

  deleteAllCartItem() {
    this.unLockMultiCart();
  }

  findPartySize() {
    let size = 0;
    this.cartItems.forEach(cartItem => {
      size += cartItem?.Size ? cartItem.Size : 0;
    });
    this.guestPartySize = size;
  }

  resetCartData(cartIndex, modifiedLockCart) {
    let cartBookObj = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
    cartBookObj = cartBookObj.filter((eachCartObj, index) => {
      return cartIndex !== index;
    });
    //  cartBookObj = cartBookObj.slice(cartIndex,1);
    this.activityService.setSessionData('CartList_' + this.activityService.restaurantMerchantCode, cartBookObj, true);
    let cartLockObj = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
    cartLockObj = cartLockObj.filter((eachCartObj, index) => {
      return cartIndex !== index;
    });
    //   cartLockObj = cartLockObj.slice(cartIndex,1);
    this.activityService.setSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, cartLockObj, true);
    this.activityService.triggerCartUpdate();
    this.activityService.operation === operationType.edit ? this.setRatePlanCalculation(true) :
      this.RegisterReservationMerchantLevelAttempt(true);
  }

  unLockMultiCart(cartIndex = null) {
    const modifiedLockCart = [];

    const CartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true) || [];

    if (cartIndex !== null) {
      modifiedLockCart.push(CartLockList[cartIndex].slotLockResp);
    } else {
      CartLockList.forEach(cartlock => {
        modifiedLockCart.push(cartlock.slotLockResp);
      });
    }
    let filteredItems = this.activityService.lockMultipleResult ? [].concat.apply([], this.activityService.lockMultipleResult).filter(x => x.SlotLockResultDTO && x.SlotLockResultDTO.SlotLockIdDTO) : [];
    if (filteredItems) {
      CartLockList.forEach(item => {
        let filteredObjects = filteredItems.filter(listObj => listObj.CartId == item.CartId)

        item.isAvailable = filteredObjects.length > 0 ? true : false;

      });
    }
    this.activityService.setSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, CartLockList, true);


    this.activityService.startLoader();
    this.subscriptions.add(
      this.activityService
        .unLockMultiPropertySessions(modifiedLockCart).subscribe(response => {
          // this.activityService.stopLoader();
          this.activityService.lockMultipleResult = null;
          /** 🐞 Bug Fix | Issue: 67776 | Root: IsMember is not properly resetted | Fix: Reset the IsMember and IsStayGuest flags | By: Hope | Date: 24-09-2026 */
          this.activityService.IsMember = false;
          this.activityService.IsStayGuest = false;
          if (cartIndex !== null) {
            this.resetCartData(cartIndex, modifiedLockCart);
          } else {
            this.activityService.emptyCartData();
          }
        }, () => {
          this.activityService.stopLoader();
        })
    );
  }

  lockMultiPropertySessions() {
    const modifiedLockCart = this.activityService.formCartLockPayLoad(this.activityService.restaurantMerchantCode);
    this.activityService.startLoader();
    this.subscriptions.add(
      this.activityService
        .lockMultiPropertySessions(modifiedLockCart).subscribe(response => {
          this.activityService.stopLoader();
          this.activityService.setLockIdsResponse(response.Payload, this.activityService.restaurantMerchantCode);
          this.activityService.lockMultipleResult = response.Payload;
        })
    );
  }

  RegisterReservationMerchantLevelAttempt(isIframeToBeDisplayed: boolean, fromEdit = false) {
    const cartObj = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true) || [];
    const cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true) || [];
    this.showCartLockWarning = true;
    if (cartLockList.length == cartLockList.filter(x => x.isAvailable).length) {
      this.showCartLockWarning = false;
    }
    const multiRegPayload = [];
    if (cartObj && cartObj.length > 0) {
      cartObj.forEach(eachActivities => {
        const registerReservationAttemptRequestDTO: any = {
          CartId: eachActivities.CartId,
          Size: +eachActivities?.Size,
          ActivityId: eachActivities?.SpecialMealId,
          CoverTypes: eachActivities?.CoverTypes,
          TableIds: eachActivities?.isNonDining ? eachActivities?.TableIds : eachActivities?.TableId,
          InstructorIds: [], // eachActivities?.InstructorIds
          BookingTypes: eachActivities?.BookingTypes,
          FromWebsite: true,
          BookingBehavior: eachActivities?.BookingBehavior,
          PartyId: this.activityService.operation === operationType.edit ? (this.activityService?.editData?.Id || null) : null,
          MemberType: this.activityService.selectedGuest?.MembershipType,
          MemberActive: this.activityService.selectedGuest?.MemberActive,
          PropertyId: +eachActivities?.PropertyId,
          RestaurantId: +eachActivities?.PropertyId,
          LocalTime: eachActivities?.LocalTime,
          SpecialMealId: eachActivities?.SpecialMealId,
          SeatingTypeId: eachActivities?.SeatingTypeId,
          isDining: eachActivities.isDining,
          isNonDining: eachActivities.isNonDining,
          Slots: !eachActivities.isNonDining ? [{
            LocalTime: eachActivities?.LocalTime,
          }] : eachActivities.Slots,
          SpecialMealName: eachActivities?.SelectedActivityInfo?.Name,
          DoesRequirePrepayment: eachActivities?.DoesRequirePrepayment,
          Price: eachActivities?.Price,
          AddOns: eachActivities.AddOns || Utilities.getSelectedAddOns(this.activityService.addOnList),
          BookingTypeInfo :eachActivities.BookingTypeInfo || null,
          BookingContacts : eachActivities.Contact ? [eachActivities.Contact, ...(eachActivities.BookingContacts || [])] : null
        };

        if (!eachActivities.isDining && !eachActivities.isNonDining) {
          registerReservationAttemptRequestDTO.SessionSlot = eachActivities?.Sessions;
          if (eachActivities.AddOns?.length > 0 && (registerReservationAttemptRequestDTO.AddOns?.length == 0)) {
            registerReservationAttemptRequestDTO.AddOns = eachActivities.AddOns;
          }
          if (registerReservationAttemptRequestDTO.BookingBehavior === BookingBehavior.ClassOrSession) {
            registerReservationAttemptRequestDTO.Slots = [];
          }
          else {
            registerReservationAttemptRequestDTO.SessionSlot = null;
          }
        }

        multiRegPayload.push(registerReservationAttemptRequestDTO);
      });      
      
      this.activityService.bannerImageHandler(multiRegPayload);
      this.activityService.startLoader();
      this.activityService.RegisterReservationAttemptMerchantLevelUniversalCart(multiRegPayload).subscribe((response: any) => {
        if (response) {
          if(!this.activityService.loaderRunning) {
            this.activityService.startLoader();
          }
          //this.preloadCartData();
          console.log(response);
          this.paymentData = this.activityService.reservationAttemptInfo = response;
          this.financialEffectId = this.activityService.reservationAttemptInfo.FinancialEffectId;
          this.paymentGateway = response.PaymentGateway;
          this.TotalAmount = response.Total;
          this.PayableAmount = response.Unpaid;
          this.totalTax = response.TaxAmount;
          if (response.ShouldCreditCardBeEntered && isIframeToBeDisplayed) {
            if (this.activityService.reservationAttemptInfo?.CreditCardIframeUrl) {
              this.LoadIframe(this.activityService.reservationAttemptInfo?.CreditCardIframeUrl);
              this.paymentOffline = false;
            }
            else {
              this.paymentOffline = true;
              this.activityService.openSnackBar(
                this.ts.instant('SorryForPaymentOffline'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
            }
          }
          this.mapSummaryDetails(response.ResponseDTOs);
          // response.ResponseDTOs[0].RatePlanTotal = {"RatePlanCalculations":[{"TimeRange":{"Start":"2023-11-02T18:00:00","End":"2023-11-02T20:00:00","Length":"02:00:00","memberDetails":[{"GuestId":12458,"GuestName":"Guest 1","RateType":"RT1","SessionCharges":260,"LineItems":[{"LineItemId":187,"Description":"Hotel guest","Quantity":1,"PreviousGrossPrice":0,"RetailPrice":100,"ItemTotal":100},{" LineItemId ":154,"Description":"Adult","Quantity":1,"PreviousGrossPrice":0,"RetailPrice":100,"ItemTotal":100},{"LineItemId":158,"Description":"Gross Court","Quantity":1,"PreviousGrossPrice":0,"RetailPrice":100,"ItemTotal":100},{"LineItemId":190,"Description":"tennis racquet","Quantity":1,"PreviousGrossPrice":0,"RetailPrice":60,"ItemTotal":60}]}]}}],"Tax":[{"TotalAmount":100,"Amount":10,"Percentage":10,"Description":"VAT"},{"TotalAmount":250,"Amount":15,"Percentage":5,"Description":"VAT"}],"TaxOnServiceCharge":[{"Amount":10,"Percentage":5,"Description":"Service Charge VAT"}],"MinRateAdjustment":0,"ActivitiesAmount":520,"NegotiatedDiscount":0,"Subtotal":520,"ServiceCharge":0,"GrandTotal":520,"RecalculateServiceCharge":true,"negotiatedReason":"Test Description"};
          // this.totalActivitiesRegistered = response.ResponseDTOs || [];
          this.totalActivitiesRegistered.map((activity, index) => {
            let cartItems = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
            let cartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
            let cartItem = cartItems.find(item => item.CartId === activity.CartId);
            activity.TimeRange = activity.RatePlanTotal.RatePlanCalculations[index].TimeRange;
            activity.Size = cartItem.Size;
            activity.isDining = cartItem.isDining;
            activity.isNonDining = cartItem.isNonDining;
            if (!cartItem) {
              cartItem = cartItems.find(item => item.CartId === activity.LockCartId);
            }
            let cartLockItem = cartLockList.find(item => item.CartId === activity.LockCartId);
            activity.SelectedActivityInfo = cartItem?.SelectedActivityInfo;
            if (cartLockItem.ActivityId) {
              activity.WidgetPrePaymentMode = this.activitiesDataDic.Property[cartLockItem.propertyId].Activity[cartLockItem.ActivityId].WidgetPrePaymentMode;
            } else {
              activity.WidgetPrePaymentMode = this.activitiesDataDic.Property[cartLockItem.propertyId].WidgetPrePaymentMode;
            }
            activity.isAvailable = cartLockItem?.isAvailable;
            activity.restaurantData = this.activityService?.widgetSettings?.PropertyWidgetSettings?.find(property => property.RestaurantId == activity.PropertyId);
          })
        this.activityService?.stopLoader();
        }
        if (this.activityService.operation === operationType.edit &&
          Object.keys(this.activityService.editData)?.length && this.activityService.editData?.Id) {
          this.getFinancialEffectCalculation();
        }
        console.log(this.totalActivitiesRegistered);
      }, () => { // error handling
        this.totalActivitiesRegistered = [];
        this.activityService.stopLoader();
      });
    } else {
      this.totalActivitiesRegistered = [];
      this.activityService.navigateToUrl('list');
      this.activityService.openSnackBar(
        this.ts.instant('noItemsAvailable'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
    }
  }
    mapSummaryDetails(response){
      let bookings = [];
      response.forEach((eachBooking) =>{
        let cartItem =  this.cartItems.find(cart => cart.CartId == eachBooking?.CartId);
        eachBooking.RatePlanTotal.Reservations?.forEach((eachItem) =>{
          eachItem.Sessions.forEach(session =>{
            bookings.push({
              Items:session.GuestPrices.length ? session.GuestPrices[0].Items : [],
              date:session.Date,
              SubTotal:session.SubTotal,
              Total:session.Total || 0,
              TimeRange:session.TimeRange,
              ActivityName:eachBooking.ActivityName,
              Size:eachBooking.Size ? eachBooking.Size : this.guestPartySize,
              WidgetPrePaymentMode : cartItem?.SpecialMealId ? this.activitiesDataDic.Property[eachBooking.PropertyId].Activity[cartItem.SpecialMealId].WidgetPrePaymentMode : this.activitiesDataDic.Property[eachBooking.PropertyId].WidgetPrePaymentMode,
              ServiceCharge: session.ServiceCharge,
              ServiceCharges: session.ServiceCharges,
              VAT: session.VAT,
              Tax: session.Tax,
              Taxes: session.Taxes,
              TotalItems: session.GuestPrices.length ? _.map(session.GuestPrices,'Items').flat() : [],
              NoShowFeeAmount: eachItem.NoShowFeeAmount
            })
          })
        })
      });
    this.overallBookings = bookings;

   
  }
  getFinancialEffectCalculation() { // need this call for single edit
    this.infoMessage = '';
    this.balanceAmount = 0;
    this.refundAmount = false;
    const partyDTO = this.buildReservationRequest();
    this.activityService.startLoader();
    this.activityService.GetFinancialEffectCalculation(partyDTO[0], this.activityService.isDining).subscribe((data: any) => {
      this.activityService.stopLoader();
      if (data) {
        this.financialData = data;
        if (data.PaymentGateway) {
          this.paymentGateway = data.PaymentGateway;
        }
        if (data.RefundOption) {
          this.refundData = data.RefundOption;
        }
        if (data.TotalAmount) {
          this.TotalAmount = data.TotalAmount;
          this.PayableAmount = data.PaymentAmount;
          this.balanceAmount = data.PaymentAmount;
          this.totalTax = (data.TaxAmount || 0);
          this.totalServiceCharge = (data.ServiceChargeAmount  || 0);
          this.taxOnServiceCharge = (data.TaxOnServiceCharge || 0);
        }
        if(data.RatePlanTotal){
          this.totalTax  = 0;
          this.totalServiceCharge = 0;
          let ratePlan  = data.RatePlanTotal
          this.totalTax = (ratePlan?.TotalTaxAmount || 0) + (ratePlan?.TotalAddonTaxAmount || 0) + (ratePlan?.MinRateAdjustment?.TaxAmount || 0);
          this.totalServiceCharge = (ratePlan?.TotalServiceChargeAmount || 0) + (ratePlan?.TotalAddonServiceChargeAmount || 0) + ( ratePlan?.MinRateAdjustment?.ServiceChargeAmount || 0);
          this.taxOnServiceCharge = (ratePlan.TotalTaxOnServiceChargeAmount || 0) + (ratePlan?.TotalAddonTaxOnServiceChargeAmount || 0) +  ( ratePlan?.MinRateAdjustment?.TaxOnServiceChargeAmount || 0);
        }
        if (this.financialData) {
          let financeEffects = this.financialData?.FinancialEffects?.[0]?.RatePlanTotal?.RatePlanCalculations?.[0];
          if (financeEffects && this.isEdit && !this.activityService.isDining && financeEffects.AddonAttemptDetails) {
            this.totalActivitiesRegistered[0].AddonAttemptDetails = financeEffects.AddonAttemptDetails;
            this.totalActivitiesRegistered[0].TotalAddonAmount = financeEffects.TotalAddOnAmount;
            this.totalActivitiesRegistered[0].TotalAmount = financeEffects.TotalAmount;
            this.totalActivitiesRegistered[0].TaxAmount = this.totalActivitiesRegistered[0].TaxAmount + financeEffects.TotalAddOnTaxAmount;
          }
        }
        let bookings = [];
        data.RatePlan?.Reservations?.forEach((eachItem) =>{
          eachItem.Sessions.forEach(session =>{
            bookings.push({
              Items:session.GuestPrices[0].Items,
              date:session.Date,
              SubTotal:session.SubTotal,
              Total:session.Total,
              TimeRange:session.TimeRange,
              ActivityName:data?.ActivityName ? data.ActivityName : this.restaurantData?.RestaurantName || null,
              Size:data.Size ? data.Size : this.guestPartySize,
              WidgetPrePaymentMode : null,
              ServiceCharge: session.ServiceCharge,
              ServiceCharges: session.ServiceCharges,
              VAT: session.VAT,
              Tax: session.Tax,
              Taxes: session.Taxes,
              NoShowFeeAmount: eachItem.NoShowFeeAmount
            })
          })
        });
        this.overallBookings = bookings;
        if (data.RedirectUrl) {
          this.isSplitPayment = false;
          this.isUserAllowedToclickConfirm = false;
          this.paymentData.ReservationAttemptId = data.ReservationAttemptId;
          // this.confirmButton.disbaledproperity = true;
          this.LoadIframe(data.RedirectUrl);
        } // else {
        switch (data.PartyPaymentType) {
          case 0: // NotSupported
            this.activityService.setMessageState(this.ts.instant('ReservationBetweenLocationPrePaidNotSupported'), 0);
            this.isUserAllowedToclickConfirm = false;
            // this.confirmButton.disbaledproperity = true;
            return;
            break;
          case 1: // NoPaymentsInvolved
            // No messaging in this case
            break;
          case 2: // NoEffect
            if(data.RetailCreditCardPaymentTokenId){
              this.infoMessage = this.ts.instant('SavedCardInfoMessageForCharge');
            }else{
              this.showFinancialEffectPopUp(this.ts.instant('NoChargeOrRefundForThisReservation'));
            }
            break;
          case 3: // NewReservationAttempt
            // paymentIframeRequired = true;
            if (this.isSelectedMealDefferedPayment()) {
              this.popUpMessage = this.ts.instant('yourCardWillBeChargedPriorToYourMealTime');
            } else {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 4: // NoFullRefund
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('NoChargeOrRefundForThisReservation');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 5: // FullRefund
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' '
              + this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 6: // NoFullRefundAndNewReservationAttempt
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('noRefundMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 7: // FullRefundAndNewReservationAttempt
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' '
              + this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 8: // PartialCharge
            if (this.activityService.reservationAttemptInfo?.ShouldCreditCardBeEntered || this.financialData?.IsCreditCardNeeded) {
              this.popUpMessage = this.ts.instant('CardNeededToUpdateThisReservation') + ' '
                + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + ' ' + this.ts.instant('enterCreditCard');
            }
            else {
              this.popUpMessage = this.ts.instant('CardUsedForTheOriginalBookingWillCharged') + ' '
                + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 9:
          case 14: // PartialRefund       
            this.refundAmount = true;
            if (this.financialData.RefundOption && this.financialData.RefundOption.length > 0) {
              // this.popUpMessage = this.ts.instant('Refund request of ') +
              // this.operationCurrency + data.PaymentAmount + this.ts.instant(' has been initiated');
              this.popUpMessage = this.ts.instant('refundRequestOf') + this.operationCurrency + data.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + this.ts.instant('hasBeenProcessed');
            } else {
              this.popUpMessage = this.ts.instant('refundMessage') + this.operationCurrency + Math.abs(data.PaymentAmount).toFixed(this.widgetSettings.NumberOfFractionalDigits) + '.<br />'
                + this.ts.instant('severalDaysMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 10: // NoShowFeeUpdated
            this.popUpMessage = this.ts.instant('IfDonotShowYouWillBeCharged') + ' ' +
              this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 11: // Authorize

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' +
                this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
          case 12: // Authorize updated

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' +
                this.operationCurrency + data.TotalAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
        }
        if (this.isEdit && this.activityService.isDining && this.activityService.selectedSpecialMeal) {
          this.totalActivitiesRegistered = this.processEditOrderSummaryList(data);
        }
        // this.bindPaymentAmountAndMessage(data.RatePlanAmount, data.SpecialMealAmount, data.TotalAmount)
        // need to check how to find deferred payment mode
        if (this.activityService.reservationAttemptInfo?.ShouldCreditCardBeEntered) {
          this.isUserAllowedToclickConfirm = false;
          // this.confirmButton.disbaledproperity = true;
          this.LoadIframe(this.activityService.reservationAttemptInfo?.CreditCardIframeUrl);
        }
        else {
          if (!data.RedirectUrl) {
            this.isUserAllowedToclickConfirm = true;
            // this.confirmButton.disbaledproperity =
            //  this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationVia == ConfirmationVia.Both;
          }
        }
        // }
      }
      setTimeout(() => {
        this.checkSubmitValidation();
      }, 200)
    });
  }

  showFinancialEffectPopUp(Message: string) {
    const popUpMessage = [{
      confirmationMessage: Message,
      dialogTitle: this.ts.instant('paymentInfo'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.financialPopUpRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '260px', true, 'No', this.ts.instant('confirm'),
      this.ts.instant('cancel'), true, '90vw');
    this.financialPopUpRef.afterClosed().subscribe(data => {
      this.checkSubmitValidation();
      if (data?.cancel) {
        // unlock session
        this.unlockSessions();
        this.activityService.emptyCartData();
      }
    });
  }

  // Order Summary List formation for dining edit scenario
  processEditOrderSummaryList(financialEffect) {
    let diningCartItem = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true)[0] || [];
    let editedDiningItem: any = {};
    let noShowFee: any = 0;
    if (diningCartItem?.CoverTypes && diningCartItem.CoverTypes.length > 0) {
      diningCartItem.CoverTypes = diningCartItem.CoverTypes.map(cover => {
        return {
          ...cover,
          Price: this.activityService.editData?.SpecialMeal?.CoverTypePrices.find(coverPrice => coverPrice.Id == cover.CoverTypeId)?.Price || 0
        }
      });
    }
    if (financialEffect?.PartyPaymentType == FinancialEffectType.NoShowFeeUpdated) {
      noShowFee = financialEffect?.TotalAmount
    }
    editedDiningItem = this.formDiningOrderList(editedDiningItem, diningCartItem,
      diningCartItem.Size,
      diningCartItem?.SelectedActivityInfo?.Name,
      financialEffect?.SpecialMealAmount,
      financialEffect?.RatePlanAmount,
      noShowFee);
     editedDiningItem.PaymentAmount = financialEffect.PaymentAmount;
    editedDiningItem.Size = diningCartItem.Size;
    editedDiningItem.isDining = diningCartItem.isDining;
    editedDiningItem.SelectedActivityInfo = diningCartItem.SelectedActivityInfo;
    return [editedDiningItem];
  }

  unlockSessions() {
    if (this.activityService.lockResult && this.activityService.lockResult.SlotLockIdDTO) {
      this.activityService.unlockSessionsUrl(this.activityService.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.activityService.lockResult = null;
        this.activityService.offTimer();
        this.activityService.navigateToUrl('slot-selection/' + this.activityService.restaurantWidgetId);
      });
    } else if (this.activityService.lockMultipleResult) {
      const lockData = Object.values(this.activityService.lockMultipleResult);
      const LockIds: number[] = [];
      lockData.forEach((innerArray:any) => {
        innerArray?.forEach(item => {
          const id = item?.SlotLockResultDTO?.SlotLockIdDTO?.Id;
          if (id !== undefined) {
            LockIds.push(id);
          }
        });
      });

      this.activityService.releaseMultiple(LockIds).subscribe(data => {
        this.activityService.lockMultipleResult = null;
        this.activityService.offTimer();
        this.activityService.navigateToUrl('slot-selection/' + this.activityService.restaurantWidgetId);
      });
    } else {
      this.activityService.offTimer();
      this.activityService.navigateToUrl('slot-selection/' + this.activityService.restaurantWidgetId);
    }
  }

  isSelectedMealDefferedPayment(): boolean {
    const isDeffered = false;
    // if (this.gs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value) {
    //   isDeffered = (this.gs.reservationFormGroup.get('reservationDetailsForm')
    // .get('specialMeal').value.DoesRequirePrepayment &&
    // !this.gs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.ChargeOnBooking) ? true : false;
    // }
    return isDeffered;
  }

  LoadGuestWaiverForm(formCode) {
    this.activityService.startLoader();
    this.activityService.GetAuthWaiverForm(this.activityService?.selectedActivities?.restaurantWidgetId, formCode).subscribe(data => {
      this.activityService.stopLoader();
      if (data) {
        this.LoadIframe(data.formURL);
        this.waiverForm = true;
        this.activityService.operation === operationType.edit ? this.setRatePlanCalculation(true) :
          this.RegisterReservationMerchantLevelAttempt(true);
      }
      else {
        this.activityService.operation === operationType.edit ? this.setRatePlanCalculation(true) :
          this.RegisterReservationMerchantLevelAttempt(true);
        this.activityService
          .openSnackBar(this.ts.instant('somethingWentWrong'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
      }
    }, error => {
      this.activityService.stopLoader();
    });
  }

  LoadIframe(iframeURl: string) {
    if (iframeURl) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURl + '&origin=' + window.location.origin);
      this.showIframe = true;
    }
    else {
      this.activityService.
        openSnackBar(this.ts.instant('somethingWentWrong'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
    }
  }

  clickToPayment() {
    console.log(this.guestDetails);
    this.formSubmitted = true;
    let action: ActionControl = this.getBookingActions(this.activityService.widgetSettings);  
    if (this.confToken) {
      this.router.navigate([`/v2/activities/confirmation/${this.activityService.restaurantMerchantCode || ''}/${this.confToken || ''}`] , {queryParams : {actionControl : action}});
    } else {
      this.reservationConfirm(true);
    }
  }
  getBookingActions(widgetSettings): ActionControl {
    if (widgetSettings?.DisplayModifyButton && widgetSettings?.DisplayCancelButton) {
      return ActionControl.CanModifyAndCancel;
    } else if (widgetSettings?.DisplayModifyButton) {
      return ActionControl.CanModify;
    } else if (widgetSettings?.DisplayCancelButton) {
      return ActionControl.CanCancel;
    } else {
      return ActionControl.None
    }
  }

  proceedReservation(waiverFormTrancationId) {
    this.showIframe = false;
    this.waiverFormTrancationId = waiverFormTrancationId;
    if (this.activityService.reservationAttemptInfo) {
      if (this.activityService.reservationAttemptInfo?.ShouldCreditCardBeEntered) {
        if (this.activityService.reservationAttemptInfo?.CreditCardIframeUrl) {
          this.LoadIframe(this.activityService.reservationAttemptInfo?.CreditCardIframeUrl);
          this.paymentOffline = false;
        }
        else {
          this.paymentOffline = true;
          this.activityService.openSnackBar(this.ts.instant('SorryForPaymentOffline'),
            this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
      }
      else {
        this.isUserAllowedToclickConfirm = true;
        if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
          this.activityService.openSnackBar(this.ts.instant('completeAllFields'),
            this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
          this.showIframe = false;
        }
        else {
          this.reservationConfirm();
        }
      }
    } else {
      this.activityService.operation === operationType.edit ? this.setRatePlanCalculation(true) :
        this.RegisterReservationMerchantLevelAttempt(true);
    }

  }

  UpdateMultiCartReservationAttempt(Dto) {
    this.activityService.startLoader();
    this.activityService.UpdateMultiCartReservationAttempt(Dto).subscribe(data => {
      this.activityService.stopLoader();
      let url = '';
      const sorrysomethingwentwromg = this.ts.instant('SorryWeGotSomeErrorWhileProcessing');
      const CCUprocessableTryAgainErrorMessage = this.ts.instant('CCUprocessableTryAgainErrorMessage');
      const ImportantErrorMessage = this.ts.instant('ImportantErrorMessage');
      const CreditCardAuthorizationError = this.ts.instant('CreditCardAuthorizationError');
      const TryAgainMessage = this.ts.instant('TryAgainMessage');
      const CardNumbershouldContainOnlyDigits = this.ts.instant('CardNumbershouldContainOnlyDigits');
      const CardNumberShouldConsists13To16Digits = this.ts.instant('CardNumberShouldConsists13To16Digits');
      const CardNumberShouldNotBlank = this.ts.instant('CardNumberShouldNotBlank');
      const SorryWeGotSomeErrorCardExpired = this.ts.instant('SorryWeGotSomeErrorWhileProcessingCardExpired');
      if (data && (data.ErrorMessage || data.ExceptionMessage ||
        (data.ValidationMessages && data.ValidationMessages.length > 0) || data.length === 0)) {
        if (data.ErrorMessage && data.ErrorMessage.length > 0) {
          if (data.ErrorMessage === 'Please try it one more time, if the problem repeats, contact to rGuestSeat@Agilysys.com') {
            url = sorrysomethingwentwromg + TryAgainMessage;
          }
          else if (data.ErrorMessage === 'We\'re sorry, but we couldn\'t process your credit card based on the information you provided. Please try again.') {
            url = sorrysomethingwentwromg + CCUprocessableTryAgainErrorMessage;
          }
          else if (data.ErrorMessage === '[IMPORTANT] Some error happens at the moment of database saving. There is a probability that the payment transaction has performed successfully but this fact hasn\'t been saved properly. Don\'t try to do it one more time. Please, contact rGuestSeat@Agilysys.com regarding this error') {
            url = sorrysomethingwentwromg + ImportantErrorMessage;
          }
          else if (data.ErrorMessage === 'The provided credit card hasn\'t been authorized succesfully') {
            url = sorrysomethingwentwromg + CreditCardAuthorizationError;
          }
          else if (data.ErrorMessage.indexOf('The card is expired') > 0) {
            url = SorryWeGotSomeErrorCardExpired;
          }
          else if (data.ErrorMessage === 'The card number should consist of only digits') {
            url = sorrysomethingwentwromg + CardNumbershouldContainOnlyDigits;
          }
          else if (data.ErrorMessage === 'The card number should consist of from 13 to 16 digits') {
            url = sorrysomethingwentwromg + CardNumberShouldConsists13To16Digits;
          }
          else if (data.ErrorMessage === 'The card number shouldn\'t be blank') {
            url = sorrysomethingwentwromg + CardNumberShouldNotBlank;
          }
          else {
            url = sorrysomethingwentwromg + data.ErrorMessage;
          }
          this.activityService.openSnackBar(url, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
        else {
          url = sorrysomethingwentwromg + TryAgainMessage;
          this.activityService.openSnackBar(url, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
        this.activityService.
          openSnackBar(url, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
      } else if (data.RedirectUrl) {
        this.activityService.offTimer();
        this.LoadIframe(data.RedirectUrl);
        setTimeout(() => {
          let msg = '';
          if(data.PendingAmount){
            msg = this.ts.instant('yourCurrentPaymentOf') + ' ' +
              this.operationCurrency + Dto.PaymentAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + this.ts.instant('isProcessedSuccessfullyPleaseProceedToPay') + this.operationCurrency + data.PendingAmount.toFixed(this.widgetSettings.NumberOfFractionalDigits) + this.ts.instant('toPlaceYourReservation');
              this.activityService.openSnackBar(msg, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'success-snackbar');              
          }else{
            msg = this.ts.instant('authCompleteMessageInfo');
            this.openInfoMessage(msg);
          }
        }, 1);
        // if (!this.isSplitPayment) {
        const timer = moment(data.ExtendedSlotLockResultDTO.ExpiresAt).diff(moment(data.ExtendedSlotLockResultDTO.LockedAt), 'seconds');
        this.activityService.showTimer = true;
        this.activityService.runTimer(timer);
        this.isSplitPayment = true;
        this.activityService.isSplitPayment$.next(true);
        // }
      }
      else {
        this.activityService.isSplitPayment$.next(false);
        const ReservationIds = this.activityService.operation === operationType.edit ?
          this.paymentData.AttemptIds ||[this.paymentData?.ReservationAttemptId || this.paymentData.ResponseDTOs?.filter(x => x.ReservationAttemptId > 0).map(x => x.ReservationAttemptId)] :
          this.paymentData.ResponseDTOs?.filter(x => x.ReservationAttemptId > 0).map(x => x.ReservationAttemptId);
        
        this.activityService.startLoader();
        this.activityService.GetRegisterMultipleReservationAttempt(ReservationIds).subscribe(regAtmptData => {
          this.activityService.stopLoader();
          if (regAtmptData) {
            let isAuthorized = true;
            regAtmptData.forEach(reservationData => {
              if (reservationData.State !== PaymentStates.Authorized && reservationData.State !== PaymentStates.ChargeCaptured) {
                isAuthorized = false;
              }
            });

            if (isAuthorized) {
              this.isUserAllowedToclickConfirm = true;
              if (!this.checkCustomTermsAndMessageOptionValidation()) {
                this.activityService.openSnackBar
                  (this.ts.instant('completeAllFields'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
                this.showIframe = false;
              }
              else {
                this.reservationConfirm();
              }
            } else {
              this.activityService.openSnackBar
                (this.ts.instant('CreditCardNotBeProcessed'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
            }
          }
        }, error => {
          this.activityService.stopLoader();
        });
      }
    }, error => {
      this.activityService.stopLoader();
    });
  }

  checkCustomTermsAndMessageOptionValidation() {
    this.formSubmitted = true;
    let isApproved = true;
    this.checkBoxErrorMessages = '';
    if (this.activityService.additionalGuestPage) {
      return true;
    }
    if (!this.checkTermsValidation()) {
      isApproved = false;
      this.checkBoxErrorMessages = this.ts.instant('pleaseCheckRequiredTermsAndConditions');
    }
    
    // 🐞 Bug Fix | Issue: 50718 | Root: Below condition validated only for activities | Fix:  validate confirmation method using cart item instead of selected activities | By: Hope | Date: 2026/03/27
    if (this.cartItems[0]?.SelectedActivityInfo.ConfirmationVia === ConfirmationVia.Both) {
      /**🐞 Bug Fix | Issue: 47078 | Root: form values undefined on checkbox change | Fix: access values from component array instead of form | By: Maniprakash V | Date: 2025/11/25 */
      const emailReminder = this.reminderSmsEmailChecks?.find(check => check.name === 'reservationConfirmationByEmail');
      const smsReminder = this.reminderSmsEmailChecks?.find(check => check.name === 'reservationConfirmationBySMS');     
      if (!emailReminder?.labelValue || !smsReminder?.labelValue) {
        isApproved = false;
        this.checkBoxErrorMessages = (this.checkBoxErrorMessages !== '') ? this.checkBoxErrorMessages + ', ' : '';
        this.checkBoxErrorMessages += this.ts.instant('mustSelectSMSandEmailConfirmation');
      }
    }
    this.checkSubmitValidation();
    return isApproved;
  }

  reservationConfirm(fromSubmit = false, isOverlapBooking: boolean = false) {

    if (!this.checkCustomTermsAndMessageOptionValidation()) {
      this.activityService.openSnackBar(this.ts.instant('completeAllFields'),
      this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
      return;
    }

    const partyDtoRequired = this.buildReservationRequest(true);

    if (this.activityService.operation === operationType.edit && this.activityService.editData) {
      if (!this.isPartySizeMatchSecondaryContactList()) {
        this.activityService.openSnackBar(this.ts.instant('partySizeMisMatchError'),
        this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        return;
      }
      this.updateReservation(partyDtoRequired, fromSubmit, isOverlapBooking);
    } else {
      this.CreateReservation(partyDtoRequired, fromSubmit, isOverlapBooking);
    }
  }

  getReminderChecksValue(reminderName: string): boolean{
    return this.reminderSmsEmailChecks?.find(({name}) => name === reminderName)?.labelValue || false;
  }

  remindVisitBySMS(){
    if(this.activityService.selectedActivities?.IsSmsReminderSupported){
      return (this.activityService.selectedActivities?.IsReservationReminderMandatory || this.getReminderChecksValue("reservationBySMS"))
    }
    return this.getReminderChecksValue("reservationBySMS");
  }

  buildReservationRequest(isBookingApiRequest?: boolean) {
    const partyDTOArray = [];
    const cartItems = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true) || [];
    cartItems.forEach((eachItem, index) => {
      const partyDTO: any = {
        CartId: eachItem.CartId,
        PropertyId: eachItem.PropertyId,
        RestaurantId: eachItem.PropertyId,
        Id: this.activityService.operation === operationType.edit ?
          (this.activityService.successBookRes?.PartyId || this.activityService?.editData?.Id || null) : null,
        Size: eachItem.Size,
        RemindAboutVisit: this.remindVisitBySMS(), // get Value froom form
        RemindAboutVisitEmail: this.getReminderChecksValue("reservationByEmail"), //
        AgreedWithTermsOfUse: true,
        Contact:this.activityService?.editData?.Contact ? Object.assign( this.activityService?.editData?.Contact, eachItem.Contact) : eachItem.Contact,
        BookingTypes: eachItem.BookingTypes,
        CoverTypes: eachItem.CoverTypes,
        Slot: !eachItem.isNonDining ? eachItem.Slot : eachItem.Slots[0],
        Slots: eachItem.Slots, // : this.buildNonDiningSLots(eachItem),
        Sessions: eachItem.Sessions,
        PartyId: this.activityService.operation === operationType.edit ?
          (this.activityService.successBookRes?.PartyId || this.activityService?.editData?.Id || null) : null,
        BookingId: this.activityService.operation === operationType.edit ?
          this.activityService.editData?.BookingId : null,
        SpecialMealId: eachItem.SpecialMealId,
        ConfirmationMessageOption: eachItem.ConfirmationVia,
        TableIds: !eachItem.isNonDining ? eachItem.TableId : eachItem.TableIds,
        InstructorIds: eachItem.StaffId?.filter(id => id > 0),
        Notes: eachItem.Notes,
        FromWebsite: true,
        LanguageId: Number(sessionStorage.getItem('languageId')),
        Language: this.activityService.language, // get language id
        ReservationAttemptId: this.activityService.operation === operationType.edit ?
          (this.paymentData?.ReservationAttemptId || ((!this.activityService.isDining && this.activityService.reservationAttemptInfo?.RatePlan.Reservations.filter(reservation => reservation.Id == eachItem.SpecialMealId)?.length) ? this.activityService.reservationAttemptInfo?.RatePlan.Reservations.find(reservation => reservation.Id == eachItem.SpecialMealId)?.ReservationAttemptId : this.getAttemptIdsForOpenBooking())) : (this.activityService.reservationAttemptInfo?.ResponseDTOs &&
            this.activityService.reservationAttemptInfo?.ResponseDTOs.find(x => x.CartId === eachItem.CartId)?.ReservationAttemptId ?
            this.activityService.reservationAttemptInfo?.ResponseDTOs.find(x => x.CartId === eachItem.CartId)?.ReservationAttemptId : null),
        ReservationAttemptIds: this.activityService.operation === operationType.create ?this.paymentData?.ResponseDTOs[0]?.ReservationAttemptIds:[],
        WaiverFormTransactionId: this.waiverFormTrancationId ? this.waiverFormTrancationId :
          (this.activityService.operation === operationType.edit && this.activityService.editData?.WaiverFormTransactionId) ?
            this.activityService.editData?.WaiverFormTransactionId : null,
        BookingBehavior: eachItem.BookingBehavior,
        StartDate: eachItem.StartDate ? new Date(eachItem.StartDate).toDateString() : null,
        EndDate: eachItem.EndDate ? new Date(eachItem.EndDate).toDateString() : null,
        ReservationAttemptIdWithSlotDTOList: (eachItem.BookingBehavior !== BookingActivity.ClassBooking)
          ? this.getOpenbookingSlotwithIds(eachItem) : [],
        // SecondaryContactsList: this.activityService.operation === operationType.edit ? this.buildSecondaryContactList() : null,
        BookingContacts: this.getBookingContacts(eachItem),
        IsForStandbyReservations: this.activityService.selectedSpecialMeal?.IsForStandbyReservations || null,
        SeatingAreaId: eachItem.isDining || eachItem.isNonDining ? eachItem.SeatingAreaId : null,
        SeatingTypeId: eachItem.isDining || eachItem.isNonDining ? eachItem.SeatingTypeId : null,
        IsCommunalTable: eachItem.isDining || eachItem.isNonDining ? eachItem.IsCommunalTable : false,
        // SelectedAddOns: eachItem.AddOns || Utilities.getSelectedAddOns(this.activityService.addOnList),
        AddOns: eachItem.AddOns || Utilities.getSelectedAddOns(this.activityService.addOnList),
        FinancialEffectId :  this.financialEffectId > 0 ? this.financialEffectId : this.getFinancialEffectId(eachItem.CartId),
        isBookingApiRequest: (isBookingApiRequest || this.activityService.bShowOverbookingErrorDialog),
        PaymentMethod : PaymentMethod.Prepayment,
        AuthorizeTransaction : this.transactions[0],
        rGuestPayResponseData: this.rGuestPayResponseData,
      };

      if(eachItem.BookingTypeInfo){
        let BookingTypeInfo  = {
          "BookingGuestTypes" : eachItem.BookingTypeInfo.BookingGuestType,
          "Input" : eachItem.BookingTypeInfo.Input,
          "Id" : eachItem.BookingTypeInfo.Id
        } 
        partyDTO["BookingTypeInfo"] = BookingTypeInfo;
      }
      
      if(this.isCardOnFilePayment(eachItem.SpecialMealId, eachItem.PropertyId)){
        partyDTO['PaymentMethod'] = PaymentMethod.Authorize;
      };
      
      if (eachItem && this.waiverFormTrancationId) {
        eachItem.WaiverFormTransactionId = this.waiverFormTrancationId ? this.waiverFormTrancationId :
          (this.activityService.operation === operationType.edit && this.activityService.editData?.WaiverFormTransactionId)
            ? this.activityService.editData?.WaiverFormTransactionId : null;
      }

      partyDTOArray.push(partyDTO);
    });
    
    return partyDTOArray;
  }

  getBookingContacts(contactItem){
    if(this.activityService?.editData?.BookingContacts?.length){
      return this.activityService.operation === operationType.edit ? this.activityService?.editData?.BookingContacts : this.activityService?.editData?.BookingContacts.filter(data => data.ContactId != this.activityService.editData?.Contact.Id);
    }
    
    return  (contactItem.Contact.SecondaryContactsList?.length ? contactItem.Contact.SecondaryContactsList : [])
  }

  sanitizeCoverTypes(coverTypes){
    if(coverTypes?.length > 0){
      coverTypes = coverTypes.filter(c=>c.Covers > 0);

      coverTypes.forEach(element => {
        if(!(element?.BookingTypeId > 0)){
          element.BookingTypeId = null;
        }
        if(!(element?.CoverTypeId > 0)){
          element.CoverTypeId = null;
        }
      });
    }

    return coverTypes;
  }

  getAttemptIdsForOpenBooking(){
    return this.activityService.reservationAttemptInfo?.RatePlan?.Reservations?.find(booking => booking.Id == 0)?.ReservationAttemptId || null
  }
  private isCardOnFilePayment(specialMealId,propertyId) : boolean {
    let selectedProperty = this.activityService.widgetSettings?.PropertyWidgetSettings.find(f => f.RestaurantId == propertyId);
    if (selectedProperty) {
      if (specialMealId) {
        let availableSpecialMeals = selectedProperty.AvailableSpecialMeals as any[];
        if (availableSpecialMeals) {
          let specialMeal = availableSpecialMeals.find(f => f.Id == specialMealId);
          if (specialMeal && specialMeal.WidgetPrePaymentMode == PaymentMode.CardOnFile) {
            return true;
          }
        }
      } else if (selectedProperty.WidgetPrePaymentMode == PaymentMode.CardOnFile) {
        return true;
      }
    }
    return false;
  }

  getFinancialEffectId(cartid){
    if(this.paymentData && this.paymentData.ResponseDTOs && this.paymentData.ResponseDTOs.length){
      var attemptResponse = this.paymentData.ResponseDTOs.find(r=>r.CartId == cartid);
      if(attemptResponse){
        return attemptResponse.FinancialEffectId;
      }
    }
    return null;
  }

  isPartySizeMatchSecondaryContactList(): boolean {
    if (this.activityService.operation === operationType.edit && this.activityService.editData?.SecondaryContacts
      && this.activityService.editData?.SecondaryContacts.length > 0
      && this.activityService.SaveBookingObj.Size < this.components?.toArray().length) {
      return false;
    }
    else {
      return true;
    }
  }

  buildSecondaryContactList() {
    const secondaryContactList: SecondaryContactDTO[] = [];
    for (let i = 0; i < this.components?.length; i++) {
      const secondaryContact = new SecondaryContactDTO();
      if (this.activityService.additionalGuestPage ||
        (!this.activityService.additionalGuestPage && this.activityService.operation === operationType.edit && i !== 0)) {
        const FormValue = this.components.toArray()[i].form.value;
        secondaryContact.FirstName = FormValue.firstName;
        secondaryContact.LastName = FormValue.lastName;
        secondaryContact.EmailAddress = FormValue.email;
        secondaryContact.PhoneNumber = FormValue.phone;
        secondaryContact.CountryId = this.components.last.config[2].value;
        secondaryContact.PartyId = this.activityService.successBookRes?.PartyId || this.activityService?.editData?.Id || null;
        secondaryContact.Notes = []; //this.getCategoryPreferencesNotes(this.components.toArray()[i].form.value, NoteType.guestNote);
        secondaryContact.Id = FormValue.id ? FormValue.id : null;
        secondaryContactList.push(secondaryContact);
      }
    }
    return secondaryContactList;
  }

  getConfirmationMessageOption() {
    if (this.activityService.selectedActivities?.ConfirmationVia === ConfirmationVia.Both) {
      // Get values directly from reminderSmsEmailChecks array instead of form
      const emailReminder = this.reminderSmsEmailChecks?.find(check => check.name === 'reservationConfirmationByEmail');
      const smsReminder = this.reminderSmsEmailChecks?.find(check => check.name === 'reservationConfirmationBySMS');
      
      if (emailReminder?.labelValue && smsReminder?.labelValue) {
        return ConfirmationVia.Both;
      }
      else if (emailReminder?.labelValue) {
        return ConfirmationVia.Email;
      }
      else if (smsReminder?.labelValue) {
        return ConfirmationVia.Sms;
      }
      else {
        return this.activityService?.selectedActivities?.ConfirmationVia;
      }
    }
    else {
      return this.activityService?.selectedActivities?.ConfirmationVia;
    }
  }

  getCoverTypes(): any {
    return this.activityService.SaveBookingObj?.CoverTypes;
  }

  getBookingTypes(): any {
    return this.activityService.SaveBookingObj?.BookingTypes;
  }

  updateReservation(partyDto, fromSubmit = false, isOverlapBooking: boolean = false) {
    if (partyDto[0]) {
      this.activityService.startLoader();
      this.activityService.updateSessionBooking(partyDto[0], this.activityService.isDining, isOverlapBooking).subscribe(data => {       
        if (data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error || msg.Type == ValidationMessageType.Consent).length === 0 && !data?.ExceptionMessage) {
          this.completeReservation(false, data?.Payload, fromSubmit);
        } else {
          this.bookingErrorHandler(data?.ExceptionMessage 
            || data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error)[0]?.Message 
            || this.ts.instant('errorWhileUpdatingReservation'), data?.ValidationMessages);
          this.enableSubmit = true;
        }
      }, error => {
        this.activityService.stopLoader();
      }, () => {
        this.activityService.stopLoader();
      });
    }
  }

  completeReservation(data, responseData, fromSubmit = false) {
    // this.bookingCompleted = true;
    // ------------------ Temporary Fix for edit scenario as cart booking id is not available on Update API ---------------------
    let isDining = this.activityService.isDining || false;
    this.confToken = responseData[0]?.CartBookingId || this.activityService.editData?.CartBookingId || '';
    this.activityService.emptyCartData();
    this.activityService.stopTimer();
    this.activityService.offTimer();
    this.activityService.openSnackBar
      (!this.isEdit ? this.ts.instant(isDining ? 'diningBookedSuccessfully' : 'activityBookedSuccessfully')
        : this.ts.instant(isDining ? 'diningUpdatedSuccessfully' : 'activityUpdatedSuccessfully'),
        this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'success-snackbar');
    this.clickToPayment();
    this.transactions = [];
  }

  CreateReservation(partyDto, fromSubmit = false, isOverlapBooking: boolean = false) {
    // have to check
    // this.activityService.SaveBookingObj.Contact = {
    //       FirstName: this.guestDetailsForm.value.primaryGuest.firstName,
    //       LastName: this.guestDetailsForm.value.primaryGuest.lastName,
    //       EmailAddress: this.guestDetailsForm.value.primaryGuest.email,
    //       PhoneNumber: this.guestDetailsForm.value.primaryGuest.phone,
    //       PIILastUsedDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
    //       ContactCustomFields: this.getCustomGuestFieldsValue(),
    //       CountryId: this.activityService.selectedCountryId, // map country code
    //       Notes: this.getCategoryPreferencesNotes(this.guestDetailsForm.value.primaryGuest),
    //       MarketingOptedIn: this.guestDetailsForm.value.primaryGuest.marketingFlag ?
    // this.guestDetailsForm.value.primaryGuest.marketingFlag :
    // (this.activityService.operation == operationType.edit &&
    // (!this.activityService.restaurantWidgetSettings$?.value?.MarketingFlagEnabled ||
    // !this.activityService.restaurantWidgetSettings$?.value?.MarketingFlagDescription)
    // && this.activityService.editPartyData$?.value?.Contact.MarketingOptedIn) ?
    //  this.activityService.editPartyData$?.value?.Contact.MarketingOptedIn : null
    //     }
    // this.activityService.TabChange$.next(4);
    if (partyDto.length > 0) {
      this.activityService.startLoader();
      this.activityService.createMultiSessionBookingrequest(partyDto, isOverlapBooking, this.saveCardToContact).subscribe((data: any) => {
        this.activityService.stopLoader();
        if (data?.Payload[0] && data?.Payload[0]?.length > 0 && data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error || msg.Type == ValidationMessageType.Consent).length === 0 && !data?.ExceptionMessage) {
          data = data.Payload[0];
          this.activityService.successBookRes = data;
          this.activityService.createActivityResponse$.next(data);
          this.activityService.primaryContact = partyDto.Contact;
          this.completeReservation(true, data, fromSubmit);
          this.transactions = [];
        } else {
          this.bookingErrorHandler(data?.ExceptionMessage 
            || data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error)[0]?.Message 
            || this.ts.instant('errorWhileCreatingReservation'), data?.ValidationMessages);
          this.enableSubmit = true;
        }
      }, error => {
        this.activityService.stopLoader();
      }, () => {
        this.activityService.stopLoader();
      });
    }
  }

  bookingErrorHandler(errorText: string, ValidationMessages?: any[]) {

    const isOverlapBookError = ValidationMessages?.filter(x => x.Type == 2).length ? true : false;
    if(isOverlapBookError) {
      errorText = ValidationMessages.find(x => x.Type == 2)?.Message || this.ts.instant('errorWhileCreatingReservation');
    }

    const popUpMessage = [{
      confirmationMessage: errorText,
      dialogTitle: this.ts.instant('warningText'),
      showAlert: true,
      isScrolable: true
    }];
    const height = '330px';
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.activityService.bShowOverbookingErrorDialog = false;
    this.bookingErrorDialogRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.clearCart, '400px', height, true, '',
                                  this.getErrorDialogPrimaryBtnLabel(isOverlapBookError), this.getErrorDialogSecondryBtnLabel(isOverlapBookError), true, '90vw');
    this.bookingErrorDialogRef.afterClosed().subscribe(data => {
      if (data.ok && !isOverlapBookError) {
        this.activityService.navigateToUrl('list');
      } else if(data.ok && isOverlapBookError){
        //TODO
        this.reservationConfirm(true, true);
      }
    });
  }

  openInfoMessage(errorText){

    const popUpMessage = [{
      confirmationMessage: errorText,
      dialogTitle: this.ts.instant('paymentInfo'),
      showAlert: true,
      isScrolable: true
    }];
    const height = '330px';
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.activityService.openCustomPopup(componentDetails, ComponentTypes.InfoPopup, '400px', height, false, '', 'Ok');    
  }

  getOpenbookingSlotwithIds(item?: any) {
    if(!item.isNonDining || this.isEdit)
      return this.paymentData?.Slots?.map(data => {
        return {
          ReservationAttemptId: data.ReservationAttemptId,
          SlotTime: data.LocalTime
        };
      });
    else 
      return this.paymentData?.ResponseDTOs.find(y => y.CartId == item.CartId)?.Slots?.map(data => {
        return {
          ReservationAttemptId: data.ReservationAttemptId,
          SlotTime: data.LocalTime
        };
      });
  }

  processTransactions(transInfo) {
    const transactions = transInfo.payments;
    const authorizeTransactions = [];

    if (transactions && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (transaction.successCode === 1) {
          let name = '';
          const paymentDetail = transaction.paymentDetail;
          const roomDetails = {
            RoomNumber: null,
            ConfirmationNumber: null,
            LastName: null
          };
          const pointsDetails = {
            AccountNumber: null,
            BucketName: null,
            Name: null,
            LoyaltyTransactionId: null
          };

          if (transaction.paymentType === 1 || transaction.paymentType === 2) { // credit card
            name = paymentDetail.accountName;
          }

          if (transaction.paymentType === 3) { // Post to room charges
            roomDetails.RoomNumber = paymentDetail.cardIssuer;
            roomDetails.ConfirmationNumber = paymentDetail.cardNumber;
            roomDetails.LastName = paymentDetail.accountName;
            name = paymentDetail.accountName;
          }
          if (transaction.paymentType === 5) { // Loyalty
            pointsDetails.BucketName = paymentDetail.tender;
            pointsDetails.AccountNumber = paymentDetail.cardNumber;
            pointsDetails.Name = paymentDetail.accountName;
            pointsDetails.LoyaltyTransactionId = paymentDetail.followOnData;
            name = paymentDetail.accountName;
          }
          const dto = {
            CardNumber: paymentDetail.cardNumber ? paymentDetail.cardNumber : '',
            ExpirationDate: paymentDetail.expirationDate ? paymentDetail.expirationDate.substring(0, 4) + paymentDetail.expirationDate.substring(4) : '',
            Name: name ? name : '',
            Token: paymentDetail.token ? paymentDetail.token : null,
            CardExpirationYearMonth: paymentDetail.cardExpiry ? paymentDetail.cardExpiry : null,
            TokenExpirationDate: paymentDetail.expirationDate ? paymentDetail.expirationDate : null,
            TransactionFollowOnData: paymentDetail.followOnData ? paymentDetail.followOnData : null,
            AuthorizeTransactionID: transaction.authorizeTransactionID,
            Amount: transaction.paidAmount,
            PaymentType: transaction.paymentType ? transaction.paymentType : null,
            InvoiceID: transaction?.invoiceID,
            TransactionDate: transaction.transactionsDate ? transaction.transactionsDate : null,
            RoomNumber: roomDetails?.RoomNumber,
            ConfirmationNumber: roomDetails?.ConfirmationNumber,
            BucketName: pointsDetails?.BucketName,
            LoyaltyAccountNumber: pointsDetails?.AccountNumber,
            LoyaltyTransactionId: pointsDetails?.LoyaltyTransactionId,
            IssuerType: paymentDetail?.tender,
            AuthCode : paymentDetail?.authCode,
            CCType : paymentDetail?.cardIssuerType,
            CCTransactionId : paymentDetail?.payTransactionID,
          };
          authorizeTransactions.push(dto);
        } else if (transaction.errorMessage) {
          this.activityService.openSnackBar
            (transaction.errorMessage, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        }
      });
      return authorizeTransactions;
    }
  }

  clearCart() {
    const popUpMessage = [{
      confirmationMessage: this.ts.instant('confirmClearCartMessage'),
      dialogTitle: this.ts.instant('clearCart'),
      showAlert: true,
      isScrolable: true
    }];
    const height = '250px';
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.clearCartDialogRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.clearCart, '400px', height, true, '', this.ts.instant('confirm'),
      this.ts.instant('cancel'), true, '90vw');
    this.clearCartDialogRef.afterClosed().subscribe(data => {
      if (data.ok) {
        this.deleteAllCartItem();
        this.activityService.navigateToPage();
       // this.activityService.navigateToUrl('list');
      }
    });
  }

  buildNonDiningSLots(item: any){
    const reservationAttemptId = this.totalActivitiesRegistered.find(x => x.CartId == item.CartId)?.ReservationAttemptId;
    if(reservationAttemptId) {
      item.Slots[0]= {
        ...item.Slots[0],
        ReservationAttemptId: reservationAttemptId 
      }
    }
    return item.Slots;
  }

  getErrorDialogPrimaryBtnLabel(isOverlapBookError: boolean) {
    if (isOverlapBookError)
      return this.ts.instant('Yes');
    else if (this.isEdit)
      return this.ts.instant('retryUpdate');
    else
      return this.ts.instant('bookAgain');
  }

  getErrorDialogSecondryBtnLabel(isOverlapBookError: boolean) {
    if (isOverlapBookError)
      return this.ts.instant('No');
    else
      return this.ts.instant('cancel');
  }

  validateForm() {
    if(this.checkBoxErrorMessages || this.showCartLockWarning) {
      this.isValidateTerms = false;
    }
    else {
      this.isValidateTerms = true;
    }
  }

}

const MESSAGES = {
  Labels: {
    description: 'description',
    quantity: 'qty',
    grossPrice: 'grossPrice',
    minRateAdjustment: 'MinRateAdjustment',
    serviceCharge: 'serviceCharges',
    totalPrice: 'totalPrice',
    tax: 'tax',
  }
}

@Pipe({
    name: 'getAddonName',
    standalone: false
})
export class GetAddonNamePipe implements PipeTransform {
  transform(addOn: any, settings, restData): any {

    if (!settings) {
      settings = restData;
    }
    return (settings?.Addons?.find(addOnItem => addOnItem.AddonId == addOn.AddonId)?.AddonName ||
              restData?.Addons?.find(addOnItem => addOnItem.AddonId == addOn.AddonId)?.AddonName || '')

  }
}

@Pipe({
    name: 'getTaxDescription',
    standalone: false
})
export class GetTaxDescriptionPipe implements PipeTransform {
  constructor(private ts: TranslateService) { }
  transform(data): string {
    let msg;
    if (data.TotalAmount) {
      this.ts.get('taxDescription', { description: data.Description, percentage: data.Percentage, amount: data.TotalAmount }).subscribe((res: string) => msg = res);
    }
    else {
      this.ts.get('serviceChargeTaxDescription', { description: data.Description, percentage: data.Percentage }).subscribe((res: string) => msg = res);
    }
    return msg;
  }
}

@Pipe({
    name: 'filterTaxType',
    standalone: false
})
export class FilterTaxTypePipe implements PipeTransform {
  constructor(private ts: TranslateService) { }
  transform(taxArray, taxType): string {
   
    return taxArray.filter(tax => tax.BookingChargeType == taxType);
  }
}

// 🐞 Bug Fix | Issue: 62649 | Issue : Same number of unique Id is adding item count and amount multiple times | Fix: Added implementation calculate count and amount based on Unique Id and Type. | By: Jerlin C S | Date: 24-July-2026
@Pipe({
    name: 'groupItemByType',
    standalone: false
})
export class GroupItemByType implements PipeTransform {
  constructor() { }
  transform(lineItem, slot, type) {
    const groupedItems = _.groupBy(slot.TotalItems || slot.Items, (item:any) => `${item.Id}_${item.Type}`);
    const groupKey = `${lineItem.Id}_${lineItem.Type}`;
    return _.sumBy(groupedItems?.[groupKey], type) || 0;
  }
}

